import * as React from 'react';
import { withTranslation } from 'react-i18next';
import LanguageSelect from '../shared/LanguageSelect';
import {
  Box,
  Typography,
  Button,
  Paper,
  Grid,
  Skeleton,
  Breadcrumbs,
  Link,
  Alert,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  IconButton,
  Tooltip,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  Switch,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Snackbar,
  Collapse,
} from '@mui/material';
import { useState, useEffect, useRef } from 'react';
import { buildDescriptionDraftKey, loadDraft } from '../../utils/draftStorage';
import { isFinnishRegistrationNumber } from '../../utils/registration';
import { getInvoiceSplitMode, getCreateInvoiceLabelKey } from '../../utils/invoiceSplit';
import DescriptionEditDialog from './DescriptionEditDialog';
import AddPartDialog from './AddPartDialog';
import AddJobDialog from './AddJobDialog';
import QuickAddDialog from './QuickAddDialog';
import EditPartDialog from './EditPartDialog';
import SwapEstimatePartDialog from '../quote-machine/SwapEstimatePartDialog';
import EditJobDialog from './EditJobDialog';
import NotesSection from './NotesSection';
import SchedulingSection from './SchedulingSection';
import PurchaseInvoicesSection from './PurchaseInvoicesSection';
import WorkOrderClockPanel from '../worktime/clock/WorkOrderClockPanel';
import AssignCustomerDialog from './AssignCustomerDialog';
import AssignBillingCustomerDialog from './AssignBillingCustomerDialog';
import DeductibleDialog from './DeductibleDialog';
import AssignEmployeeDialog from './AssignEmployeeDialog';
import VehicleInfoModal from './VehicleInfoModal';
import ServiceBookLink from './ServiceBookLink';
import VehicleDetailsDialog from '../vehicles/VehicleDetailsDialog';
import ShareMaintenanceDialog from './ShareMaintenanceDialog';
import EventLogDialog from './EventLogDialog';
import OrderDiscountDialog from './OrderDiscountDialog';
import CreateInvoiceDialog from '../invoices/CreateInvoiceDialog';
import OfferDialog from './OfferDialog';
import QuickPayConfirmDialog from './QuickPayConfirmDialog';
import QuoteSentBanner from './QuoteSentBanner';
import QuoteHistoryDialog from './QuoteHistoryDialog';
import { quoteStatusColor, quoteStatusLabel } from './quoteUtils';
import ChangeVehicleDialog from './ChangeVehicleDialog';
import { useParams, useNavigate, useLocation, useSearchParams, Link as RouterLink } from 'react-router-dom';
import axios from 'axios';
import { useUserStore } from 'store';
import CancelMaintenanceDialog from './CancelMaintenanceDialog';
import DecimalField from '../shared/DecimalField';
import ConfirmStateChangeDialog from './ConfirmStateChangeDialog';
import WaitingReasonDialog from './WaitingReasonDialog';
import CompletionDialog from './CompletionDialog';
import { requiresConfirmation, needsOdometerPrompt, getInvoiceReopenInfo } from './stateTransitions';
import SupplierOrderDialog from './SupplierOrderDialog';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import HistoryIcon from '@mui/icons-material/History';
import PeopleIcon from '@mui/icons-material/People';
import PersonIcon from '@mui/icons-material/Person';
import BusinessIcon from '@mui/icons-material/Business';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import AddIcon from '@mui/icons-material/Add';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import CancelIcon from '@mui/icons-material/Cancel';
import InventoryIcon from '@mui/icons-material/Inventory';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import BuildIcon from '@mui/icons-material/Build';
import DescriptionIcon from '@mui/icons-material/Description';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import EditIcon from '@mui/icons-material/Edit';
import EngineeringIcon from '@mui/icons-material/Engineering';
import LocalGasStationIcon from '@mui/icons-material/LocalGasStation';
import SpeedIcon from '@mui/icons-material/Speed';
import SettingsIcon from '@mui/icons-material/Settings';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import ReplayIcon from '@mui/icons-material/Replay';
import ShareIcon from '@mui/icons-material/Share';
import CheckIcon from '@mui/icons-material/Check';
import ReceiptIcon from '@mui/icons-material/Receipt';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import PrintIcon from '@mui/icons-material/Print';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import PaymentsIcon from '@mui/icons-material/Payments';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import TroubleshootIcon from '@mui/icons-material/Troubleshoot';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import ScheduleIcon from '@mui/icons-material/Schedule';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { fi } from 'date-fns/locale';
import { formatDate, formatDateOnly, formatQuantity } from '../../utils';
import { formatPrice } from '../../utils/vat';
import { calcJobsLaborTime, formatLaborHours, lineEstimateMinutes } from '../../utils/laborTime';
import StatusBadge from '../shared/StatusBadge';
import CardHeader from '../shared/CardHeader';
import ExtraWorkRequestDialog from './ExtraWorkRequestDialog';
import WorkOrderConfirmationDialog from './WorkOrderConfirmationDialog';
import RecordOdometerDialog from './RecordOdometerDialog';
import ExtraLookupConfirmDialog, { shouldSkipExtraLookupConfirm } from '../vehicles/ExtraLookupConfirmDialog';
import HelpButton from '../shared/HelpButton';
import SearchIcon from '@mui/icons-material/Search';
import FlashOnIcon from '@mui/icons-material/FlashOn';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import AiEstimateJobDialog from './AiEstimateJobDialog';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import Badge from '@mui/material/Badge';
import TireRepairIcon from '@mui/icons-material/TireRepair';
import TireSwapDialog from '../tire_hotel/TireSwapDialog';
import CustomerDialog from '../customers/CustomerDialog';
import { InternalNotesAlert } from '../shared/InternalNote';
import { VehicleServiceInfoBox } from '../shared/VehicleServiceInfo';
import ApplyPackageDialog from './ApplyPackageDialog';
import CopyFromMaintenanceDialog from './CopyFromMaintenanceDialog';
import OemServiceDialog from './oem/OemServiceDialog';
import BoschDiagnosticsDialog from './BoschDiagnosticsDialog';
import CabasEstimateDialog from '../cabas/CabasEstimateDialog';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import WorkOrderTimeline from './WorkOrderTimeline';

import { can } from '../../utils/access';
import { printPdfBlob } from '../../utils/printPdf';
import { DAMAGE_TYPES } from '../../utils/damageTypes';

const PARTS_ORDER_CONFIG = {
  not_ordered: { color: '#ef4444', bg: '#fee2e2' },
  ordered: { color: '#d97706', bg: '#fef3c7' },
  arrived: { color: '#059669', bg: '#d1fae5' },
  not_needed: { color: '#64748b', bg: '#f1f5f9' },
};

const dateStringToDate = (dateStr) => {
  if (!dateStr) return null;
  return new Date(dateStr + 'T00:00:00');
};

const dateToDateString = (date) => {
  if (!date || isNaN(date.getTime())) return '';
  const year = date.getFullYear();
  if (year < 1900 || year > 2100) return '';
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  return `${year}-${month}-${day}`;
};

// Read a work-order-PDF note preference from localStorage. The single "Include notes"
// option was split into separate customer/internal toggles; fall back to the old
// `workOrderIncludeNotes` key so a previously-on choice keeps showing notes.
const readWorkOrderNotePref = (key) => {
  const stored = localStorage.getItem(key);
  if (stored !== null) return stored === 'true';
  return localStorage.getItem('workOrderIncludeNotes') === 'true';
};

// The insurance fields save on blur when they differ from these server-side baselines.
function withOriginalInsuranceFields(data) {
  return {
    ...data,
    _original_insurance_claim_number: data.insurance_claim_number,
    _original_deductible_amount: data.deductible_amount,
    _original_insurance_damage_date: data.insurance_damage_date,
    _original_insurance_damage_description: data.insurance_damage_description,
    _original_insurance_inspector_name: data.insurance_inspector_name,
    _original_insurance_inspector_code: data.insurance_inspector_code,
    _original_insurance_inspection_date: data.insurance_inspection_date,
    _original_repair_start_date: data.repair_start_date,
    _original_repair_end_date: data.repair_end_date,
  };
}

function MaintenanceProcessView({ t }) {
  const [partModalOpen, setPartModalOpen] = useState(false);
  const [taskModalOpen, setTaskModalOpen] = useState(false);
  const [quickAddPartOpen, setQuickAddPartOpen] = useState(false);
  const [quickAddJobOpen, setQuickAddJobOpen] = useState(false);
  const [aiEstimateOpen, setAiEstimateOpen] = useState(false);
  const [cancelMaintenanceModalOpen, setCancelMaintenanceModalOpen] = useState(false);
  const [customerModalOpen, setCustomerModalOpen] = useState(false);
  const [customerEditDialogOpen, setCustomerEditDialogOpen] = useState(false);
  const [billingCustomerModalOpen, setBillingCustomerModalOpen] = useState(false);
  const [leasingCustomerModalOpen, setLeasingCustomerModalOpen] = useState(false);
  const [deductibleDialogOpen, setDeductibleDialogOpen] = useState(false);
  const [employeeModalOpen, setEmployeeModalOpen] = useState(false);
  const [vehicleModalOpen, setVehicleModalOpen] = useState(false);
  const [vehicleHistoryDialogOpen, setVehicleHistoryDialogOpen] = useState(false);
  const [vehicleHistoryInitialTab, setVehicleHistoryInitialTab] = useState(0);
  const [shareModalOpen, setShareModalOpen] = useState(false);
  const [eventLogDialogOpen, setEventLogDialogOpen] = useState(false);
  const [invoiceDialogOpen, setInvoiceDialogOpen] = useState(false);
  const [quickPayMethod, setQuickPayMethod] = useState(null);
  const [offerDialogOpen, setOfferDialogOpen] = useState(false);
  const [quoteHistoryOpen, setQuoteHistoryOpen] = useState(false);
  // Line reordering. Off by default so the row layout is unchanged for everyone
  // who does not need it — turning it on reveals up/down arrows per row.
  const [changeVehicleDialogOpen, setChangeVehicleDialogOpen] = useState(false);
  const [reorderMode, setReorderMode] = useState(false);
  const [reordering, setReordering] = useState(false);
  const [pientarvikelisaBusy, setPientarvikelisaBusy] = useState(false);
  const [extraWorkDialogOpen, setExtraWorkDialogOpen] = useState(false);
  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
  const [odometerDialogOpen, setOdometerDialogOpen] = useState(false);
  const [editPartDialogOpen, setEditPartDialogOpen] = useState(false);
  const [swapEstimateLine, setSwapEstimateLine] = useState(null); // Tarjousautomaatti estimate line being swapped
  const [editJobDialogOpen, setEditJobDialogOpen] = useState(false);
  const [orderDiscountDialogOpen, setOrderDiscountDialogOpen] = useState(false);
  const [selectedPart, setSelectedPart] = useState(null);
  const [selectedJob, setSelectedJob] = useState(null);
  const [maintenance, setMaintenance] = useState(null);
  // Copy the VIN from the header. Feedback is the icon flipping to a check mark (the tooltip
  // alone never shows on a phone tap).
  const [vinCopied, setVinCopied] = useState(false);
  const handleCopyVin = async () => {
    const vin = maintenance?.vehicle?.vin;
    if (!vin) return;
    try {
      await navigator.clipboard.writeText(vin);
      setVinCopied(true);
      setTimeout(() => setVinCopied(false), 1800);
    } catch {
      // Clipboard unavailable (plain http / denied permission): the VIN stays selectable as text
    }
  };
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [completionDialogOpen, setCompletionDialogOpen] = useState(false);
  const [waitingReasonDialogOpen, setWaitingReasonDialogOpen] = useState(false);
  const [pendingStateChange, setPendingStateChange] = useState(null);
  const [applyPackageDialogOpen, setApplyPackageDialogOpen] = useState(false);
  const [copyFromDialogOpen, setCopyFromDialogOpen] = useState(false);
  const [oemDialogOpen, setOemDialogOpen] = useState(false);
  const [actionsMenuAnchor, setActionsMenuAnchor] = useState(null);
  const [editWorkNumberOpen, setEditWorkNumberOpen] = useState(false);
  const [editWorkNumberValue, setEditWorkNumberValue] = useState('');
  const [editDescriptionOpen, setEditDescriptionOpen] = useState(false);
  // Drives the "unsaved draft" badge on the description card. The draft itself is
  // owned by DescriptionEditDialog (kept out of this large component to avoid
  // re-rendering the whole page on every keystroke).
  const [hasDescriptionDraft, setHasDescriptionDraft] = useState(false);
  const [workOrderLoading, setWorkOrderLoading] = useState(false);
  const [workOrderDialogOpen, setWorkOrderDialogOpen] = useState(false);
  const [workOrderLanguage, setWorkOrderLanguage] = useState('fi');
  const [workOrderIncludePrices, setWorkOrderIncludePrices] = useState(() => localStorage.getItem('workOrderIncludePrices') === 'true');
  const [workOrderIncludeCustomerNotes, setWorkOrderIncludeCustomerNotes] = useState(() => readWorkOrderNotePref('workOrderIncludeCustomerNotes'));
  const [workOrderIncludeInternalNotes, setWorkOrderIncludeInternalNotes] = useState(() => readWorkOrderNotePref('workOrderIncludeInternalNotes'));
  const [workOrderIncludeSignatures, setWorkOrderIncludeSignatures] = useState(() => localStorage.getItem('workOrderIncludeSignatures') === 'true');
  const [workOrderShowPartCodes, setWorkOrderShowPartCodes] = useState(() => localStorage.getItem('workOrderShowPartCodes') !== 'false');
  const [workOrderIncludeSchedule, setWorkOrderIncludeSchedule] = useState(() => localStorage.getItem('workOrderIncludeSchedule') !== 'false');
  const [vehicleLookupLoading, setVehicleLookupLoading] = useState(false);
  const [vehicleLookupQuota, setVehicleLookupQuota] = useState(null);
  const [extraLookupDialogOpen, setExtraLookupDialogOpen] = useState(false);
  const [extraLookupQuotaInfo, setExtraLookupQuotaInfo] = useState(null);
  const [saveErrorSnackbar, setSaveErrorSnackbar] = useState(false);
  const [offerSentSnackbar, setOfferSentSnackbar] = useState(null);
  // Set when AddMaintenanceDialog created the order but the OEM package attach failed
  const location = useLocation();
  const [oemAttachFailedOpen, setOemAttachFailedOpen] = useState(Boolean(location.state?.oemAttachFailed));
  const [oemAttachedOpen, setOemAttachedOpen] = useState(false);
  const [oemRefreshFailedOpen, setOemRefreshFailedOpen] = useState(false);
  const [boschDialogOpen, setBoschDialogOpen] = useState(false);
  const [boschSavedSnackbar, setBoschSavedSnackbar] = useState(null);
  const [cabasDialogOpen, setCabasDialogOpen] = useState(false);
  const [cabasSnackbar, setCabasSnackbar] = useState(null);
  const [insuranceDialogOpen, setInsuranceDialogOpen] = useState(false);
  const [supplierOrderDialogOpen, setSupplierOrderDialogOpen] = useState(false);
  const [supplierOrderIntegration, setSupplierOrderIntegration] = useState(null);
  const [tireSwapDialogOpen, setTireSwapDialogOpen] = useState(false);
  const [marginInfoOpen, setMarginInfoOpen] = useState(false);
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { currentOrganization } = useUserStore();
  const canManageInvoices = can(currentOrganization, 'invoices.manage');
  // A new invoice can be created when the work is done and no active invoice exists yet
  // (credit-noted invoices do not count; a combined invoice blocks).
  const hasNoActiveInvoice = (maintenance?.invoices || [])
    .filter((inv) => inv.invoice_type !== 'INV02' && inv.status !== 'combined')
    .every((inv) => inv.has_active_credit_note)
    && !(maintenance?.invoices || []).some((inv) => inv.status === 'combined');
  const canCreateInvoice = ['completed', 'picked_up'].includes(maintenance?.state)
    && canManageInvoices
    && hasNoActiveInvoice;
  const canSeeCosts = can(currentOrganization, 'costs.view_purchase_prices');
  const canViewMargins = canSeeCosts && can(currentOrganization, 'costs.view_margins');
  // Work order sub-action keys (editable per organization); the backend enforces the same keys.
  const canCreate = can(currentOrganization, 'work_orders.create');
  const canEdit = can(currentOrganization, 'work_orders.edit');
  const canChangeState = can(currentOrganization, 'work_orders.change_state');
  const canAddParts = can(currentOrganization, 'work_orders.add_parts');
  const canAddJobs = can(currentOrganization, 'work_orders.add_jobs');
  const canEditPrices = can(currentOrganization, 'work_orders.edit_prices');
  const canRequestApproval = can(currentOrganization, 'work_orders.request_approval');
  const canDocuments = can(currentOrganization, 'work_orders.documents');
  // Same states as the work order PDF item in the Actions menu.
  const canPrintWorkOrder = canDocuments
    && ['planned', 'in_progress', 'completed', 'waiting', 'vehicle_in_workshop'].includes(maintenance?.state);
  const tireHotelEnabled = currentOrganization?.tire_hotel_enabled ?? false;
  // Per org + work order key for the fault-description draft (null until both known).
  const descriptionDraftKey = buildDescriptionDraftKey(currentOrganization?.organization_id, id);

  const setMaintenanceState = async (state, options = {}) => {
    try {
      const response = await axios.patch(`/api/maintenances/${id}/set_state/`, { state, ...options });
      setMaintenance(response.data);
    } catch (err) {
      // The organization requires an odometer reading (e.g. switched on after this tab loaded):
      // show the backend's translated reason instead of the generic one.
      const data = err?.response?.data;
      setSaveErrorSnackbar(data?.code === 'odometer_required' && typeof data.error === 'string' ? data.error : true);
    }
  };

  // requiresConfirmation / getInvoiceReopenInfo live in ./stateTransitions (shared with the
  // calendar context menu); behaviour here is unchanged.

  // Handle state change with optional confirmation
  const handleStateChange = (targetState) => {
    if (!canChangeState) return;
    // Special case: completing maintenance opens specialized dialog with notification options
    if (maintenance?.state === 'in_progress' && targetState === 'completed') {
      setCompletionDialogOpen(true);
      return;
    }

    // Special case: waiting state opens reason selection dialog
    if (targetState === 'waiting') {
      setWaitingReasonDialogOpen(true);
      return;
    }

    // A finishing move on a work order without its own odometer reading always gets the
    // confirm dialog, which carries the reading field.
    if (requiresConfirmation(maintenance?.state, targetState) || needsOdometerPrompt(maintenance, targetState)) {
      setPendingStateChange(targetState);
      setConfirmDialogOpen(true);
    } else {
      setMaintenanceState(targetState);
    }
  };

  const handleWaitingWithReason = (reason) => {
    setMaintenanceState('waiting', { waiting_reason: reason });
    setWaitingReasonDialogOpen(false);
  };

  // Confirm the pending state change. `extra` is the odometer reading from the dialog, if any.
  const confirmStateChange = (extra = {}) => {
    if (pendingStateChange) {
      const isReopen = ['completed', 'picked_up'].includes(maintenance?.state)
        && pendingStateChange === 'in_progress';
      const invoiceInfo = getInvoiceReopenInfo(maintenance);

      if (isReopen && invoiceInfo.hasDraftInvoices && !invoiceInfo.hasBlockingInvoices && !invoiceInfo.hasKoontilasku) {
        setMaintenanceState(pendingStateChange, { cancel_draft_invoices: true, ...extra });
      } else {
        setMaintenanceState(pendingStateChange, extra);
      }
      setPendingStateChange(null);
    }
  };

  // Handle work number edit
  const handleOpenWorkNumberEdit = () => {
    setEditWorkNumberValue(maintenance?.work_number || '');
    setEditWorkNumberOpen(true);
  };

  const handleSaveWorkNumber = async () => {
    try {
      const response = await axios.patch(`/api/maintenances/${id}/`, {
        work_number: editWorkNumberValue,
      });
      setMaintenance(response.data);
      setEditWorkNumberOpen(false);
    } catch (err) {
      setError(err.message);
    }
  };

  // Handle description edit. The dialog (DescriptionEditDialog) owns the in-progress
  // text and its localStorage draft; here we only open it and persist on save.
  const handleOpenDescriptionEdit = () => {
    setEditDescriptionOpen(true);
  };

  const descriptionInitialShowToCustomer = maintenance?.description
    ? (maintenance?.show_description_to_customer || false)
    : (currentOrganization?.default_show_description_to_customer ?? false);

  const handleSaveDescriptionApi = async ({ description, show_description_to_customer }) => {
    // Throws on failure so the dialog can keep the text and show an error.
    const response = await axios.patch(`/api/maintenances/${id}/`, {
      description,
      show_description_to_customer,
    });
    setMaintenance(response.data);
  };

  // Keep the "unsaved draft" badge on the description card in sync with storage
  // (covers the case where a draft was left behind by a failed save before reload).
  useEffect(() => {
    const draft = loadDraft(descriptionDraftKey);
    setHasDescriptionDraft(!!draft && (draft.description || '') !== (maintenance?.description || ''));
  }, [descriptionDraftKey, maintenance?.description]);

  const getDefaultWorkOrderLanguage = () => maintenance?.customer?.preferred_language
    || currentOrganization?.default_language
    || 'fi';

  // Open work order PDF dialog
  const handleOpenWorkOrderDialog = () => {
    setActionsMenuAnchor(null);
    setWorkOrderLanguage(getDefaultWorkOrderLanguage());
    setWorkOrderIncludePrices(localStorage.getItem('workOrderIncludePrices') === 'true');
    setWorkOrderIncludeCustomerNotes(readWorkOrderNotePref('workOrderIncludeCustomerNotes'));
    setWorkOrderIncludeInternalNotes(readWorkOrderNotePref('workOrderIncludeInternalNotes'));
    setWorkOrderIncludeSignatures(localStorage.getItem('workOrderIncludeSignatures') === 'true');
    setWorkOrderShowPartCodes(localStorage.getItem('workOrderShowPartCodes') !== 'false');
    setWorkOrderIncludeSchedule(localStorage.getItem('workOrderIncludeSchedule') !== 'false');
    setWorkOrderDialogOpen(true);
  };

  // Open work order PDF in new tab with dialog options
  const handleOpenWorkOrderInTab = async () => {
    try {
      setWorkOrderLoading(true);
      setWorkOrderDialogOpen(false);

      const response = await axios.get(
        `/api/maintenances/${maintenance.id}/work_order_pdf/`,
        {
          params: {
            language: workOrderLanguage,
            preview: 'true',
            include_prices: workOrderIncludePrices,
            include_customer_notes: workOrderIncludeCustomerNotes,
            include_internal_notes: workOrderIncludeInternalNotes,
            include_signatures: workOrderIncludeSignatures,
            show_part_codes: workOrderShowPartCodes,
            include_schedule: workOrderIncludeSchedule,
          },
          responseType: 'blob',
        }
      );

      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      window.open(url, '_blank');
    } catch (err) {
      console.error('Failed to generate work order', err);
      setError(t('Failed to generate work order'));
    } finally {
      setWorkOrderLoading(false);
    }
  };

  // Print the work order PDF without leaving the page. The header button passes no
  // language and prints with the customer's default language and the options
  // remembered from the dialog; the dialog passes the language chosen in it.
  const handlePrintWorkOrder = async (language) => {
    try {
      setWorkOrderLoading(true);
      setWorkOrderDialogOpen(false);

      const response = await axios.get(
        `/api/maintenances/${maintenance.id}/work_order_pdf/`,
        {
          params: {
            language: language || getDefaultWorkOrderLanguage(),
            preview: 'true',
            include_prices: workOrderIncludePrices,
            include_customer_notes: workOrderIncludeCustomerNotes,
            include_internal_notes: workOrderIncludeInternalNotes,
            include_signatures: workOrderIncludeSignatures,
            show_part_codes: workOrderShowPartCodes,
            include_schedule: workOrderIncludeSchedule,
          },
          responseType: 'blob',
        }
      );

      printPdfBlob(response.data);
    } catch (err) {
      console.error('Failed to generate work order', err);
      setError(t('Failed to generate work order'));
    } finally {
      setWorkOrderLoading(false);
    }
  };

  // Handle work order PDF download
  const handleDownloadWorkOrder = async () => {
    try {
      setWorkOrderLoading(true);
      setWorkOrderDialogOpen(false);

      const response = await axios.get(
        `/api/maintenances/${maintenance.id}/work_order_pdf/`,
        { params: { language: workOrderLanguage, include_prices: workOrderIncludePrices, include_customer_notes: workOrderIncludeCustomerNotes, include_internal_notes: workOrderIncludeInternalNotes, include_signatures: workOrderIncludeSignatures, show_part_codes: workOrderShowPartCodes, include_schedule: workOrderIncludeSchedule }, responseType: 'blob' }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      const vehicleReg = maintenance?.vehicle?.registration_number || 'ajoneuvo';
      link.setAttribute('download', `Tyomaarays_${vehicleReg}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Failed to generate work order', err);
      setError(t('Failed to generate work order'));
    } finally {
      setWorkOrderLoading(false);
    }
  };

  useEffect(() => {
    const fetchMaintenance = async () => {
      try {
        const response = await axios.get(`/api/maintenances/${id}/`);
        setMaintenance(withOriginalInsuranceFields(response.data));
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchMaintenance();
  }, [id]);

  // Deep link from the onboarding checklist: /maintenances/:id?addPart=1 opens the
  // add-part dialog once the work order has loaded, then drops the param so a reload
  // or a manual close does not re-open it.
  const [searchParams, setSearchParams] = useSearchParams();
  const addPartDeepLinkHandled = useRef(false);
  useEffect(() => {
    if (addPartDeepLinkHandled.current) return;
    if (!maintenance) return;
    if (searchParams.get('addPart') !== '1') return;

    addPartDeepLinkHandled.current = true;
    setPartModalOpen(true);
    const next = new URLSearchParams(searchParams);
    next.delete('addPart');
    setSearchParams(next, { replace: true });
  }, [maintenance, searchParams, setSearchParams]);

  // Deep link from the dashboard "Laskuttamatta" widget: /maintenances/:id?createInvoice=1
  // opens the create-invoice dialog once the work order has loaded, under the same conditions
  // as the "Luo lasku" button below (state, role, no active invoice), then drops the param.
  const createInvoiceDeepLinkHandled = useRef(false);
  useEffect(() => {
    if (createInvoiceDeepLinkHandled.current) return;
    if (!maintenance) return;
    if (searchParams.get('createInvoice') !== '1') return;

    createInvoiceDeepLinkHandled.current = true;
    if (canCreateInvoice) setInvoiceDialogOpen(true);
    const next = new URLSearchParams(searchParams);
    next.delete('createInvoice');
    setSearchParams(next, { replace: true });
  }, [maintenance, searchParams, setSearchParams, canCreateInvoice]);

  // Deep link from Tarjousautomaatti "Luo ja lähetä asiakkaalle": /maintenances/:id?sendQuote=1
  // opens the quote send dialog once the work order has loaded, under the same conditions as
  // the "Luo tarjous" button (quote state, request_approval permission), then drops the param.
  const sendQuoteDeepLinkHandled = useRef(false);
  useEffect(() => {
    if (sendQuoteDeepLinkHandled.current) return;
    if (!maintenance) return;
    if (searchParams.get('sendQuote') !== '1') return;

    sendQuoteDeepLinkHandled.current = true;
    if (maintenance.state === 'quote' && canRequestApproval) setOfferDialogOpen(true);
    const next = new URLSearchParams(searchParams);
    next.delete('sendQuote');
    setSearchParams(next, { replace: true });
  }, [maintenance, searchParams, setSearchParams, canRequestApproval]);

  // Light refetch of just the current state (after clock auto-start / reopen) so the status
  // badge + work-time panel reflect the new state without clobbering in-progress edits.
  const refetchMaintenanceState = async () => {
    try {
      const res = await axios.get(`/api/maintenances/${id}/`);
      setMaintenance((prev) =>
        prev
          ? { ...prev, state: res.data.state, state_display: res.data.state_display, waiting_reason: res.data.waiting_reason }
          : res.data,
      );
    } catch {
      /* ignore */
    }
  };

  // Fetch vehicle lookup quota
  useEffect(() => {
    const fetchQuota = async () => {
      try {
        const response = await axios.get('/api/vehicles/lookup-quota/');
        setVehicleLookupQuota(response.data);
      } catch (err) {
        console.log('Failed to fetch lookup quota:', err.message);
      }
    };
    fetchQuota();
  }, []);

  // Vehicle lookup handler
  const handleVehicleLookup = async (confirmExtra = false) => {
    const vehicle = maintenance?.vehicle;
    if (!vehicle?.id || !vehicle?.registration_number) return;

    setVehicleLookupLoading(true);
    try {
      const response = await axios.post(`/api/vehicles/${vehicle.id}/lookup-and-update/`, {});
      const data = response.data;

      if (data.skipped && data.reason === 'quota_exceeded') {
        // Over quota — need to use the lookup endpoint with confirm_extra
        if (!confirmExtra && !shouldSkipExtraLookupConfirm()) {
          // Fetch fresh quota info for the dialog
          try {
            const quotaResp = await axios.get('/api/vehicles/lookup-quota/');
            setVehicleLookupQuota(quotaResp.data);
            setExtraLookupQuotaInfo({
              included_lookups: quotaResp.data.included_lookups,
              used_this_period: quotaResp.data.used_this_period,
              extra_lookup_price: quotaResp.data.extra_lookup_price,
            });
          } catch {
            setExtraLookupQuotaInfo({
              included_lookups: 0,
              used_this_period: 0,
              extra_lookup_price: 0.30,
            });
          }
          setExtraLookupDialogOpen(true);
          setVehicleLookupLoading(false);
          return;
        }

        // Confirmed extra lookup — use the lookup endpoint directly
        const lookupResp = await axios.post('/api/vehicles/lookup/', {
          registration_number: vehicle.registration_number,
          confirm_extra: true,
        });

        if (lookupResp.data.success && lookupResp.data.vehicle) {
          // Now call lookup-and-update again to save to the vehicle record
          const updateResp = await axios.post(`/api/vehicles/${vehicle.id}/lookup-and-update/`, {});
          if (updateResp.data?.success && updateResp.data?.vehicle) {
            setMaintenance(prev => ({ ...prev, vehicle: updateResp.data.vehicle }));
          }
        }
      } else if (data.success && data.vehicle) {
        setMaintenance(prev => ({ ...prev, vehicle: data.vehicle }));
      }

      // Refresh quota after lookup
      try {
        const quotaResp = await axios.get('/api/vehicles/lookup-quota/');
        setVehicleLookupQuota(quotaResp.data);
      } catch {}
    } catch (err) {
      console.error('Vehicle lookup failed:', err);
    } finally {
      setVehicleLookupLoading(false);
    }
  };

  // Calculate total prices with VAT breakdown
  const calculateTotals = () => {
    let totalExclVat = 0;
    let totalInclVat = 0;
    let totalVat = 0;
    let displaySubtotal = 0;
    const vatByRate = {};
    let partsCostTotal = 0;
    let partsRevenueTotal = 0;
    let partsTotalInclVat = 0;
    let partsWithoutCostCount = 0;

    if (maintenance?.parts) {
      maintenance.parts.forEach(part => {
        const lineExcl = parseFloat(part.line_total) || 0;
        const lineIncl = parseFloat(part.line_total_incl_vat) || lineExcl;
        const vatAmount = parseFloat(part.vat_amount) || (lineIncl - lineExcl);
        const vatRate = parseFloat(part.vat_rate) || 25.5;
        const isMargin = part.is_margin_vat_scheme;

        totalExclVat += lineExcl;
        totalInclVat += lineIncl;
        displaySubtotal += lineIncl;
        // incl-VAT, not excl: for a margin-VAT part line_total is a back-calculated
        // synthetic value, whereas line_total_incl_vat is what the customer pays.
        partsTotalInclVat += lineIncl;

        // Margin calculation: accumulate parts cost and revenue.
        //
        // Margin-VAT parts (voittomarginaalijärjestelmä, used parts) work differently
        // from normal parts and must not be measured against the catalog cost price:
        //
        //   cost    = what was actually paid for the used part. margin_vat_purchase_price
        //             is per unit and VAT-inclusive, because no VAT was deductible on it.
        //   revenue = the gross sale minus the VAT the workshop owes, which under this
        //             scheme is charged on the margin only (vat_amount already holds it).
        //
        // That keeps "myynti − ostohinta = kate" true AND comparable with normal parts,
        // where both sides are likewise net of VAT. Worked example at 25,5 %: sell 200,
        // bought for 100 -> margin 100, VAT owed 20,32, so revenue 179,68 and kate 79,68
        // — exactly what the workshop keeps.
        const qty = parseFloat(part.quantity) || 0;
        if (isMargin) {
          const purchaseInclVat = parseFloat(part.margin_vat_purchase_price) || 0;
          if (purchaseInclVat > 0) {
            partsCostTotal += purchaseInclVat * qty;
            partsRevenueTotal += lineIncl - vatAmount;
          } else {
            // Snapshot missing (the field is nullable): counting the gross sale as pure
            // profit would flatter the margin, so report it as missing cost data instead.
            partsWithoutCostCount++;
            partsRevenueTotal += lineIncl - vatAmount;
          }
        } else {
          const costPrice = parseFloat(part.cost_price) || 0;
          if (costPrice > 0) {
            partsCostTotal += costPrice * qty;
          } else {
            partsWithoutCostCount++;
          }
          partsRevenueTotal += lineExcl;
        }

        // Only include NORMAL VAT in breakdown (never margin VAT)
        if (!isMargin) {
          totalVat += vatAmount;
          if (!vatByRate[vatRate]) {
            vatByRate[vatRate] = { amount: 0, base: 0 };
          }
          vatByRate[vatRate].amount += vatAmount;
          vatByRate[vatRate].base += lineExcl;
        }
      });
    }

    let jobsCostTotal = 0;
    let jobsRevenueTotal = 0;
    let jobsTotalInclVat = 0;
    let jobsWithoutCostCount = 0;

    if (maintenance?.jobs) {
      maintenance.jobs.forEach(job => {
        const lineExcl = parseFloat(job.line_total) || 0;
        const lineIncl = parseFloat(job.line_total_incl_vat) || lineExcl;
        const vatAmount = parseFloat(job.vat_amount) || (lineIncl - lineExcl);
        const vatRate = parseFloat(job.vat_rate) || 25.5;

        totalExclVat += lineExcl;
        totalInclVat += lineIncl;
        totalVat += vatAmount;
        displaySubtotal += lineIncl;
        jobsTotalInclVat += lineIncl;

        // Job margin calculation
        const jobCostPrice = parseFloat(job.job_cost_price) || 0;
        const qty = parseFloat(job.quantity) || 0;
        if (jobCostPrice > 0) {
          jobsCostTotal += jobCostPrice * qty;
        } else {
          jobsWithoutCostCount++;
        }
        jobsRevenueTotal += lineExcl;

        if (!vatByRate[vatRate]) {
          vatByRate[vatRate] = { amount: 0, base: 0 };
        }
        vatByRate[vatRate].amount += vatAmount;
        vatByRate[vatRate].base += lineExcl;
      });
    }

    // An order-level discount reduces what the workshop actually earns, but it lives
    // outside the lines, so raw line totals overstate the margin. Split it across the
    // two groups by revenue share and give the remainder to jobs — same approach the
    // backend uses when apportioning a discount across split invoices, and it avoids a
    // rounding residual going missing.
    //
    // order_discount_total is incl-VAT, so derive the excl-VAT figure from the pair of
    // subtotals the API already sends; margin is computed on VAT-exclusive money.
    const grossRevenue = partsRevenueTotal + jobsRevenueTotal;
    const orderDiscountExclVat = Math.max(
      0,
      (parseFloat(maintenance?.subtotal_excl_vat) || 0) - (parseFloat(maintenance?.total_excl_vat) || 0),
    );
    const partsDiscountShare = grossRevenue > 0
      ? orderDiscountExclVat * (partsRevenueTotal / grossRevenue)
      : 0;
    const jobsDiscountShare = orderDiscountExclVat - partsDiscountShare;

    // Revenue after the order discount — this is what the margin figures are built on,
    // so "myynti − ostohinta = kate" holds exactly on screen.
    const partsNetRevenue = partsRevenueTotal - partsDiscountShare;
    const jobsNetRevenue = jobsRevenueTotal - jobsDiscountShare;

    const partsMargin = partsNetRevenue - partsCostTotal;
    const jobsMargin = jobsNetRevenue - jobsCostTotal;
    const totalMargin = partsMargin + jobsMargin;
    const totalMarginRevenue = partsNetRevenue + jobsNetRevenue;

    return {
      totalExclVat,
      totalInclVat,
      totalVat,
      displaySubtotal,
      vatByRate,
      partsCostTotal,
      partsRevenueTotal,
      partsNetRevenue,
      partsTotalInclVat,
      partsMargin,
      partsMarginPercent: partsNetRevenue > 0 ? (partsMargin / partsNetRevenue) * 100 : null,
      partsWithoutCostCount,
      jobsCostTotal,
      jobsRevenueTotal,
      jobsNetRevenue,
      jobsTotalInclVat,
      jobsMargin,
      jobsMarginPercent: jobsNetRevenue > 0 ? (jobsMargin / jobsNetRevenue) * 100 : null,
      jobsWithoutCostCount,
      totalMargin,
      totalMarginRevenue,
      totalMarginCost: partsCostTotal + jobsCostTotal,
      totalMarginPercent: totalMarginRevenue > 0
        ? (totalMargin / totalMarginRevenue) * 100
        : null,
    };
  };

  const totals = maintenance ? calculateTotals() : { totalExclVat: 0, totalInclVat: 0, totalVat: 0, vatByRate: {} };
  const quickPayTotal = maintenance?.total_with_vat != null ? maintenance.total_with_vat : totals.totalInclVat;
  // Quick cash/card payment: only when one normal invoice would be created (split modes
  // produce several invoices for different payers) and there is something to pay.
  const canQuickPay = canCreateInvoice
    && can(currentOrganization, 'invoices.mark_paid')
    && getInvoiceSplitMode(maintenance) === null
    && parseFloat(quickPayTotal) > 0;
  // "Työaika yhteensä" in the Jobs card, for booking the calendar without adding lines up by hand.
  const laborTime = calcJobsLaborTime(maintenance?.jobs);

  /**
   * Move a part or job one step up/down and persist the whole group order.
   *
   * Sends the complete id list rather than a pairwise swap: the endpoint rewrites
   * display_order in one atomic pass, so a dropped request can never leave the
   * work order half-reordered. Applies optimistically and rolls back on failure.
   */
  const handleMoveLine = async (group, index, direction) => {
    if (reordering) return;
    const items = (group === 'parts' ? maintenance?.parts : maintenance?.jobs) || [];
    const target = index + direction;
    if (target < 0 || target >= items.length) return;

    const reordered = [...items];
    [reordered[index], reordered[target]] = [reordered[target], reordered[index]];

    const previous = maintenance;
    setMaintenance((prev) => ({ ...prev, [group]: reordered }));
    setReordering(true);
    try {
      const response = await axios.post(
        `/api/maintenances/${maintenance.id}/reorder-lines/`,
        { [group]: reordered.map((item) => item.id) },
      );
      setMaintenance(response.data);
    } catch (err) {
      setMaintenance(previous);
      setError(t('Reordering failed. Please try again.'));
    } finally {
      setReordering(false);
    }
  };

  // Handle part click to edit
  const handlePartClick = (part) => {
    if (!canAddParts) return;
    if (isDone) return;
    setSelectedPart(part);
    setEditPartDialogOpen(true);
  };

  const handleTogglePientarvikelisa = async () => {
    // Guard against double-clicks: the button stays visible until the response arrives,
    // and two overlapping requests used to create two surcharge lines.
    if (pientarvikelisaBusy) return;
    setPientarvikelisaBusy(true);
    try {
      const response = await axios.post(`/api/maintenances/${maintenance.id}/toggle-pientarvikelisa/`);
      setMaintenance(response.data);
    } catch (err) {
      console.error('Failed to toggle pientarvikelisä:', err);
    } finally {
      setPientarvikelisaBusy(false);
    }
  };

  const handlePartsOrderStatusChange = async (newStatus) => {
    try {
      const response = await axios.post(`/api/maintenances/${maintenance.id}/set-parts-order-status/`, { status: newStatus });
      setMaintenance(response.data);
    } catch (err) {
      console.error('Failed to set parts order status:', err);
    }
  };

  // Handle job click to edit
  const handleJobClick = (job) => {
    if (!canAddJobs) return;
    if (isDone) return;
    setSelectedJob(job);
    setEditJobDialogOpen(true);
  };

  const handleAiJobCreated = (maintenanceData, createdJobId) => {
    setAiEstimateOpen(false);
    const createdJob = maintenanceData?.jobs?.find(j => j.id === createdJobId);
    if (createdJob) {
      setSelectedJob(createdJob);
      setEditJobDialogOpen(true);
    }
  };

  const getNextStateButton = () => {
    switch (maintenance?.state) {
      case 'quote':
        return {
          label: t('Convert to maintenance'),
          state: 'planned',
          icon: <PlayArrowIcon />,
        };
      case 'planned':
        return {
          label: t('Start Maintenance'),
          state: 'in_progress',
          icon: <PlayArrowIcon />,
        };
      case 'in_progress':
        return {
          label: t('Finish Maintenance'),
          state: 'completed',
          icon: <PlayArrowIcon />,
        };
      case 'completed':
        return {
          label: t('Mark as picked up'),
          state: 'picked_up',
          icon: <PlayArrowIcon />,
        };
      case 'waiting':
        return {
          label: t('Continue work'),
          state: 'in_progress',
          icon: <PlayArrowIcon />,
        };
      case 'vehicle_in_workshop':
        return {
          label: t('Start Maintenance'),
          state: 'in_progress',
          icon: <PlayArrowIcon />,
        };
      default:
        return null;
    }
  };

  // Check if maintenance is in a "done" state (no more edits allowed except notes)
  const isDone = ['completed', 'picked_up', 'cancelled'].includes(maintenance?.state);
  // The order discount stays editable on a completed work order until it is invoiced
  // (invoice, cash or card), so the price can still be rounded at the counter.
  const canEditOrderDiscount = canEditPrices
    && !maintenance?.billing_customer_is_insurance
    && (!isDone || (maintenance?.state === 'completed' && hasNoActiveInvoice));

  const supplierOrderGroups = React.useMemo(() => {
    if (!maintenance?.parts) return [];
    const groups = {};
    maintenance.parts.forEach(part => {
      if (part.supplier_integration_id && !part.is_supplier_ordered && !part.supplier_order_skipped && part.supplier_supports_ordering !== false) {
        if (!groups[part.supplier_integration_id]) {
          groups[part.supplier_integration_id] = {
            integrationId: part.supplier_integration_id,
            integrationName: part.supplier_display_name,
            parts: [],
          };
        }
        groups[part.supplier_integration_id].parts.push(part);
      }
    });
    return Object.values(groups);
  }, [maintenance?.parts]);

  // Count items awaiting customer confirmation
  const countPendingConfirmation = () => {
    const pendingParts = maintenance?.parts?.filter(p => p.awaiting_confirmation) || [];
    const pendingJobs = maintenance?.jobs?.filter(j => j.awaiting_confirmation) || [];
    return pendingParts.length + pendingJobs.length;
  };

  if (loading) {
    return (
      <Box>
        <Skeleton variant="rectangular" height={200} sx={{ mb: 3, borderRadius: 2 }} />
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Skeleton variant="rectangular" height={200} sx={{ borderRadius: 2 }} />
          </Grid>
          <Grid item xs={12} md={6}>
            <Skeleton variant="rectangular" height={200} sx={{ borderRadius: 2 }} />
          </Grid>
        </Grid>
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 4, textAlign: 'center' }}>
        <Typography color="error">{t('Error')}: {error}</Typography>
      </Box>
    );
  }

  const nextStateButton = getNextStateButton();

  return (
    <Box data-testid="maintenance-detail-page">
      <Snackbar
        open={!!saveErrorSnackbar}
        autoHideDuration={6000}
        onClose={() => setSaveErrorSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setSaveErrorSnackbar(false)} severity="error" sx={{ width: '100%' }}>
          {typeof saveErrorSnackbar === 'string' ? saveErrorSnackbar : t('Saving failed')}
        </Alert>
      </Snackbar>
      <Snackbar
        open={oemAttachFailedOpen}
        autoHideDuration={12000}
        onClose={() => setOemAttachFailedOpen(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOemAttachFailedOpen(false)} severity="warning" sx={{ width: '100%' }}>
          {t('oem.attachFailedNotice')}
        </Alert>
      </Snackbar>
      <Snackbar
        open={oemRefreshFailedOpen}
        autoHideDuration={6000}
        onClose={() => setOemRefreshFailedOpen(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOemRefreshFailedOpen(false)} severity="error" sx={{ width: '100%' }}>
          {t('oem.fetchError')}
        </Alert>
      </Snackbar>
      <Snackbar
        open={oemAttachedOpen}
        autoHideDuration={5000}
        onClose={() => setOemAttachedOpen(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOemAttachedOpen(false)} severity="success" sx={{ width: '100%' }}>
          {t('oem.attachedNotice')}
        </Alert>
      </Snackbar>
      <Snackbar
        open={!!offerSentSnackbar}
        autoHideDuration={6000}
        onClose={() => setOfferSentSnackbar(null)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOfferSentSnackbar(null)} severity="success" sx={{ width: '100%' }}>
          {offerSentSnackbar}
        </Alert>
      </Snackbar>
      <Snackbar
        open={!!boschSavedSnackbar}
        autoHideDuration={5000}
        onClose={() => setBoschSavedSnackbar(null)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setBoschSavedSnackbar(null)} severity="success" sx={{ width: '100%' }}>
          {boschSavedSnackbar}
        </Alert>
      </Snackbar>
      <Snackbar
        open={!!cabasSnackbar}
        autoHideDuration={6000}
        onClose={() => setCabasSnackbar(null)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setCabasSnackbar(null)} severity={cabasSnackbar?.severity || 'success'} sx={{ width: '100%' }}>
          {cabasSnackbar?.message}
        </Alert>
      </Snackbar>
      {/* Breadcrumb */}
      <Breadcrumbs
        separator={<ChevronRightIcon fontSize="small" sx={{ color: 'text.disabled' }} />}
        sx={{ mb: 3 }}
      >
        <Link
          component={RouterLink}
          to="/maintenances"
          underline="hover"
          sx={{ color: 'text.secondary', fontSize: '14px' }}
        >
          {t('Maintenances')}
        </Link>
        <Typography sx={{ color: 'text.primary', fontWeight: 500, fontSize: '14px' }}>
          {maintenance?.vehicle?.registration_number}
        </Typography>
      </Breadcrumbs>

      {/* Header Card */}
      <Paper
        elevation={0}
        sx={{
          mb: 3,
          background: 'linear-gradient(135deg, #fafbfc 0%, #f0f4f8 100%)',
          border: '1px solid',
          borderColor: 'divider',
          overflow: 'hidden',
        }}
      >
        {/* Top Row - Registration, Status & Actions */}
        <Box
          sx={{
            p: { xs: 2, md: '20px 24px' },
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: 'space-between',
            alignItems: { xs: 'flex-start', md: 'center' },
            gap: { xs: 2, md: 2.5 },
            borderBottom: 1,
            borderColor: 'divider',
            bgcolor: 'background.paper',
          }}
        >
          {/* Left: Vehicle Identity */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            {/* Vehicle Icon with History Button */}
            <Box sx={{ position: 'relative' }}>
              <Box
                onClick={() => setVehicleModalOpen(true)}
                sx={{
                  width: { xs: 52, md: 60 },
                  height: { xs: 52, md: 60 },
                  bgcolor: 'rgba(49, 130, 206, 0.1)',
                  borderRadius: '14px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                  cursor: 'pointer',
                  transition: 'all 0.15s',
                  '&:hover': {
                    bgcolor: 'rgba(49, 130, 206, 0.2)',
                    transform: 'scale(1.02)',
                  },
                }}
              >
                <DirectionsCarIcon sx={{ fontSize: 28, color: 'secondary.main' }} />
              </Box>
              {/* Vehicle History Button */}
              <Tooltip title={t('vehicles.viewHistory')}>
                <IconButton
                  size="small"
                  onClick={() => { setVehicleHistoryInitialTab(0); setVehicleHistoryDialogOpen(true); }}
                  sx={{
                    position: 'absolute',
                    bottom: -4,
                    right: -4,
                    width: 24,
                    height: 24,
                    bgcolor: 'background.paper',
                    border: 1,
                    borderColor: 'divider',
                    '&:hover': {
                      bgcolor: 'action.hover',
                    },
                  }}
                >
                  <HistoryIcon sx={{ fontSize: 14 }} />
                </IconButton>
              </Tooltip>
            </Box>

            {/* Registration & Basic Info */}
            <Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
                {/* Work Number - Editable */}
                {maintenance?.work_number && (
                  <Chip
                    label={`#${maintenance.work_number}`}
                    size="small"
                    onClick={handleOpenWorkNumberEdit}
                    sx={{
                      fontWeight: 600,
                      fontSize: '13px',
                      cursor: 'pointer',
                      '&:hover': { bgcolor: 'action.hover' },
                    }}
                  />
                )}
                <Typography
                  variant="h4"
                  sx={{
                    fontSize: { xs: '22px', md: '26px' },
                    fontWeight: 700,
                    color: 'text.primary',
                    fontFamily: "'Plus Jakarta Sans', sans-serif",
                    letterSpacing: '-0.5px',
                  }}
                >
                  {maintenance?.vehicle?.registration_number}
                </Typography>
                <StatusBadge status={maintenance?.state} detail={maintenance?.waiting_reason ? t(`waiting_reason.${maintenance.waiting_reason}`) : undefined} data-testid="maintenance-status" />
                {/* Quote indicator: a sent quote exists; click for every version and its answer */}
                {maintenance?.latest_quote && (
                  <Chip
                    size="small"
                    variant="outlined"
                    icon={<RequestQuoteIcon sx={{ fontSize: 16 }} />}
                    color={quoteStatusColor(maintenance.latest_quote)}
                    label={`${t('quoteSnapshot.indicator', { date: formatDateOnly(maintenance.latest_quote.sent_at) })} · ${quoteStatusLabel(maintenance.latest_quote, t)}`}
                    onClick={() => setQuoteHistoryOpen(true)}
                    data-testid="quote-indicator"
                    sx={{ fontWeight: 600, cursor: 'pointer' }}
                  />
                )}
              </Box>
              {/* Vehicle Info - Clickable */}
              <Box
                data-testid="vehicle-info-button"
                onClick={() => setVehicleModalOpen(true)}
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 0.5,
                  cursor: 'pointer',
                  mt: 0.5,
                  '&:hover': { '& .open-icon': { opacity: 1 } },
                }}
              >
                <Typography sx={{ fontSize: '15px', color: 'text.secondary' }}>
                  {maintenance?.vehicle?.manufacturer} {maintenance?.vehicle?.model}
                  {maintenance?.vehicle?.year_model && ` (${maintenance.vehicle.year_model})`}
                </Typography>
                <OpenInNewIcon className="open-icon" sx={{ fontSize: 14, color: 'text.disabled', ml: 0.5, opacity: 0.5, transition: 'opacity 0.15s' }} />
              </Box>
              {/* VIN with a copy button: workshops paste it into parts catalogues and OEM portals */}
              {maintenance?.vehicle?.vin && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.25 }} data-testid="vehicle-vin-line">
                  <Tooltip title={t('VIN')} placement="bottom-start">
                    <Typography sx={{ fontSize: '13px', color: 'text.secondary' }} data-testid="vehicle-vin">
                      {maintenance.vehicle.vin}
                    </Typography>
                  </Tooltip>
                  <Tooltip title={vinCopied ? t('Copied!') : t('Copy to clipboard')}>
                    <IconButton
                      size="small"
                      onClick={handleCopyVin}
                      aria-label={t('Copy to clipboard')}
                      data-testid="copy-vin-button"
                      data-copied={vinCopied ? 'true' : 'false'}
                      sx={{ p: 0.25, color: vinCopied ? 'success.main' : 'text.disabled', '&:hover': { color: 'text.primary' } }}
                    >
                      {vinCopied ? <CheckIcon sx={{ fontSize: 14 }} /> : <ContentCopyIcon sx={{ fontSize: 14 }} />}
                    </IconButton>
                  </Tooltip>
                </Box>
              )}
              <ServiceBookLink manufacturer={maintenance?.vehicle?.manufacturer} />
            </Box>
          </Box>

          {/* Right: Action Buttons */}
          <Box
            sx={{
              display: 'flex',
              gap: 1.25,
              flexWrap: 'wrap',
              width: { xs: '100%', md: 'auto' },
            }}
          >
            {/* Tire Swap Button */}
            {tireHotelEnabled && maintenance?.vehicle?.id &&
             maintenance?.has_tire_hotel_cards &&
             ['planned', 'in_progress'].includes(maintenance?.state) && (
              <Button
                variant="outlined"
                startIcon={<TireRepairIcon />}
                onClick={() => setTireSwapDialogOpen(true)}
                aria-label={t('tire_hotel.tire_swap')}
                data-testid="tire-swap-open"
                sx={{
                  borderColor: 'divider',
                  color: 'text.secondary',
                  minWidth: { xs: 0, sm: 64 },
                  px: { xs: 1.5, sm: 2 },
                  py: 1.25,
                  borderRadius: '10px',
                  fontWeight: 500,
                  fontFamily: "'Plus Jakarta Sans', sans-serif",
                  flex: { xs: 'none', sm: 1, md: 'none' },
                  // Icon only on phones: the label would eat the row the primary actions need
                  '& .MuiButton-startIcon': { mx: { xs: 0, sm: undefined } },
                  '&:hover': {
                    borderColor: 'text.primary',
                    bgcolor: 'background.paper',
                  },
                }}
              >
                <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>
                  {t('tire_hotel.tire_swap')}
                </Box>
              </Button>
            )}

            {/* Create / resend quote (quote state) - mirrored at the bottom next to the price summary */}
            {maintenance?.state === 'quote' && canRequestApproval && (
              <Button
                variant="contained"
                startIcon={<DescriptionIcon />}
                onClick={() => setOfferDialogOpen(true)}
                data-testid="quote-create-button-header"
                sx={{
                  bgcolor: 'primary.main',
                  color: 'white',
                  px: 2,
                  py: 1.25,
                  borderRadius: '10px',
                  fontWeight: 500,
                  fontFamily: "'Plus Jakarta Sans', sans-serif",
                  flex: { xs: 1, md: 'none' },
                  '&:hover': {
                    bgcolor: 'primary.dark',
                  },
                }}
              >
                {maintenance?.latest_quote || maintenance?.last_offer_sent ? t('Resend quote') : t('Create quote')}
              </Button>
            )}

            {/* Create Invoice Button */}
            {canCreateInvoice && (
              <Button
                variant="contained"
                startIcon={<ReceiptIcon />}
                onClick={() => setInvoiceDialogOpen(true)}
                sx={{
                  bgcolor: 'primary.main',
                  color: 'white',
                  px: 2,
                  py: 1.25,
                  borderRadius: '10px',
                  fontWeight: 500,
                  fontFamily: "'Plus Jakarta Sans', sans-serif",
                  flex: { xs: 1, md: 'none' },
                  '&:hover': {
                    bgcolor: 'primary.dark',
                  },
                }}
              >
                {t(getCreateInvoiceLabelKey(getInvoiceSplitMode(maintenance)))}
              </Button>
            )}

            {/* Quick payment: create the invoice and take cash/card in one go */}
            {canQuickPay && (
              <>
                <Button
                  variant="outlined"
                  color="success"
                  startIcon={<CreditCardIcon />}
                  onClick={() => setQuickPayMethod('card')}
                  aria-label={t('Card payment')}
                  data-testid="quick-pay-card"
                  sx={{ minWidth: { xs: 0, sm: 64 }, px: { xs: 1.5, sm: 2 }, py: 1.25, borderRadius: '10px', fontWeight: 500, fontFamily: "'Plus Jakarta Sans', sans-serif", flex: { xs: 'none', sm: 1, md: 'none' }, whiteSpace: 'nowrap', '& .MuiButton-startIcon': { mx: { xs: 0, sm: undefined } } }}
                >
                  <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>
                    {t('Card payment')}
                  </Box>
                </Button>
                <Button
                  variant="outlined"
                  color="success"
                  startIcon={<PaymentsIcon />}
                  onClick={() => setQuickPayMethod('cash')}
                  aria-label={t('Cash payment')}
                  data-testid="quick-pay-cash"
                  sx={{ minWidth: { xs: 0, sm: 64 }, px: { xs: 1.5, sm: 2 }, py: 1.25, borderRadius: '10px', fontWeight: 500, fontFamily: "'Plus Jakarta Sans', sans-serif", flex: { xs: 'none', sm: 1, md: 'none' }, whiteSpace: 'nowrap', '& .MuiButton-startIcon': { mx: { xs: 0, sm: undefined } } }}
                >
                  <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>
                    {t('Cash payment')}
                  </Box>
                </Button>
              </>
            )}

            {/* One-click work order print */}
            {canPrintWorkOrder && (
              <Tooltip title={t('Print work order')}>
                <span style={{ display: 'flex' }}>
                  <Button
                    variant="outlined"
                    onClick={() => handlePrintWorkOrder()}
                    disabled={workOrderLoading}
                    aria-label={t('Print work order')}
                    data-testid="work-order-print-button"
                    sx={{
                      borderColor: 'divider',
                      color: 'text.secondary',
                      minWidth: 0,
                      px: 1.5,
                      py: 1.25,
                      borderRadius: '10px',
                      '&:hover': {
                        borderColor: 'text.primary',
                        bgcolor: 'background.paper',
                      },
                    }}
                  >
                    {workOrderLoading ? <CircularProgress size={20} /> : <PrintIcon />}
                  </Button>
                </span>
              </Tooltip>
            )}

            {/* Actions Dropdown Menu */}
            <Button
              variant="outlined"
              startIcon={<MoreVertIcon />}
              onClick={(e) => setActionsMenuAnchor(e.currentTarget)}
              sx={{
                borderColor: 'divider',
                color: 'text.secondary',
                px: 2,
                py: 1.25,
                borderRadius: '10px',
                fontWeight: 500,
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                flex: { xs: 1, md: 'none' },
                '&:hover': {
                  borderColor: 'text.primary',
                  bgcolor: 'background.paper',
                },
              }}
            >
              {t('Actions')}
            </Button>
            <Menu
              anchorEl={actionsMenuAnchor}
              open={Boolean(actionsMenuAnchor)}
              onClose={() => setActionsMenuAnchor(null)}
              PaperProps={{
                sx: {
                  mt: 1,
                  minWidth: 200,
                  borderRadius: '10px',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                },
              }}
            >
              <MenuItem
                onClick={() => {
                  setShareModalOpen(true);
                  setActionsMenuAnchor(null);
                }}
              >
                <ListItemIcon>
                  <ShareIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>{t('Share')}</ListItemText>
              </MenuItem>
              {canRequestApproval && (
              <MenuItem
                onClick={() => {
                  setConfirmationDialogOpen(true);
                  setActionsMenuAnchor(null);
                }}
              >
                <ListItemIcon>
                  <CheckCircleOutlineIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>
                  {maintenance?.confirmation_status === 'declined'
                    ? t('confirmation.reRequestConfirmation')
                    : t('confirmation.requestConfirmation')
                  }
                </ListItemText>
              </MenuItem>
              )}
              <MenuItem
                onClick={() => {
                  setEventLogDialogOpen(true);
                  setActionsMenuAnchor(null);
                }}
              >
                <ListItemIcon>
                  <HistoryIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>{t('Event Log')}</ListItemText>
              </MenuItem>
              {currentOrganization?.has_bosch_core_integration &&
                (maintenance?.vehicle?.registration_number || maintenance?.vehicle?.vin) && (
                <MenuItem
                  data-testid="bosch-fetch-menu-item"
                  onClick={() => {
                    setBoschDialogOpen(true);
                    setActionsMenuAnchor(null);
                  }}
                >
                  <ListItemIcon>
                    <TroubleshootIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>{t('bosch.fetchDiagnostics')}</ListItemText>
                </MenuItem>
              )}
              {currentOrganization?.has_cabas_integration && canEdit && canAddParts && canAddJobs && (
                <MenuItem
                  data-testid="cabas-fetch-menu-item"
                  onClick={() => {
                    setCabasDialogOpen(true);
                    setActionsMenuAnchor(null);
                  }}
                >
                  <ListItemIcon>
                    <RequestQuoteIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>{t('cabas.fetchEstimate')}</ListItemText>
                </MenuItem>
              )}
              {!isDone && canAddParts && (
                <MenuItem
                  onClick={() => {
                    setApplyPackageDialogOpen(true);
                    setActionsMenuAnchor(null);
                  }}
                >
                  <ListItemIcon>
                    <Inventory2Icon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>{t('huoltopaketit.applyTitle')}</ListItemText>
                </MenuItem>
              )}
              {!isDone && canCreate && (
                <MenuItem
                  onClick={() => {
                    setCopyFromDialogOpen(true);
                    setActionsMenuAnchor(null);
                  }}
                >
                  <ListItemIcon>
                    <ContentCopyIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>{t('copyFromMaintenance.title')}</ListItemText>
                </MenuItem>
              )}
              {['planned', 'in_progress', 'completed', 'waiting', 'vehicle_in_workshop'].includes(maintenance?.state) && (
                <>
                  <Divider />
                  {canDocuments && (
                  <MenuItem
                    onClick={handleOpenWorkOrderDialog}
                    disabled={workOrderLoading}
                  >
                    <ListItemIcon>
                      {workOrderLoading ? (
                        <CircularProgress size={20} />
                      ) : (
                        <DescriptionIcon fontSize="small" />
                      )}
                    </ListItemIcon>
                    <ListItemText>{t('Download / Open Work Order PDF')}</ListItemText>
                  </MenuItem>
                  )}
                </>
              )}
              {/*
                Quote/cost-estimate PDF is reachable from every state, not just `quote`.
                Mechanics print it to check the work before the price is promised, and
                after the job is done a cost estimate is still worth reprinting.
                Emailing it stays quote-only — see the `allowSend` prop below.
              */}
              {maintenance?.state !== 'cancelled' && canDocuments && (
                <MenuItem
                  onClick={() => {
                    setOfferDialogOpen(true);
                    setActionsMenuAnchor(null);
                  }}
                >
                  <ListItemIcon>
                    <RequestQuoteIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>{t('Download / Open Quote PDF')}</ListItemText>
                </MenuItem>
              )}
              {maintenance?.latest_quote && (
                <MenuItem
                  onClick={() => {
                    setQuoteHistoryOpen(true);
                    setActionsMenuAnchor(null);
                  }}
                  data-testid="quote-history-menu-item"
                >
                  <ListItemIcon>
                    <HistoryIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>{t('quoteSnapshot.sentQuotes')}</ListItemText>
                </MenuItem>
              )}
              {/*
                Fixing a mistyped registration. Mirrors the backend guard: blocked
                once an invoice exists (the invoice snapshots the registration), so
                the user never hits the 400.
              */}
              {!isDone && maintenance?.state !== 'cancelled'
                && canEdit && !(maintenance?.invoices || []).some(inv => inv.status !== 'cancelled') && (
                <MenuItem
                  onClick={() => {
                    setChangeVehicleDialogOpen(true);
                    setActionsMenuAnchor(null);
                  }}
                >
                  <ListItemIcon>
                    <DirectionsCarIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>{t('Change vehicle')}</ListItemText>
                </MenuItem>
              )}
              {['planned', 'in_progress'].includes(maintenance?.state) && (
                <>
                  <Divider />
                  <MenuItem
                    sx={{ display: canChangeState ? 'flex' : 'none' }}
                    onClick={() => {
                      handleStateChange('waiting');
                      setActionsMenuAnchor(null);
                    }}
                  >
                    <ListItemIcon>
                      <HourglassEmptyIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>{t('Waiting for parts')}</ListItemText>
                  </MenuItem>
                </>
              )}
              {maintenance?.state === 'planned' && (
                <MenuItem
                  sx={{ display: canChangeState ? 'flex' : 'none' }}
                  onClick={() => {
                    handleStateChange('vehicle_in_workshop');
                    setActionsMenuAnchor(null);
                  }}
                >
                  <ListItemIcon>
                    <DirectionsCarIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>{t('Vehicle in workshop')}</ListItemText>
                </MenuItem>
              )}
              {maintenance?.state === 'planned' && (
                <>
                  <Divider />
                  <MenuItem
                    sx={{ display: canChangeState ? 'flex' : 'none' }}
                    onClick={() => {
                      handleStateChange('quote');
                      setActionsMenuAnchor(null);
                    }}
                    sx={{ color: 'secondary.main' }}
                  >
                    <ListItemIcon>
                      <ReplayIcon fontSize="small" sx={{ color: 'secondary.main' }} />
                    </ListItemIcon>
                    <ListItemText>{t('Back to quote')}</ListItemText>
                  </MenuItem>
                </>
              )}
              {['waiting', 'vehicle_in_workshop'].includes(maintenance?.state) && (
                <>
                  <Divider />
                  <MenuItem
                    sx={{ display: canChangeState ? 'flex' : 'none' }}
                    onClick={() => {
                      handleStateChange('planned');
                      setActionsMenuAnchor(null);
                    }}
                    sx={{ color: 'secondary.main' }}
                  >
                    <ListItemIcon>
                      <ReplayIcon fontSize="small" sx={{ color: 'secondary.main' }} />
                    </ListItemIcon>
                    <ListItemText>{t('Back to planned')}</ListItemText>
                  </MenuItem>
                </>
              )}
              {(maintenance?.state === 'in_progress' || isDone) && <Divider />}
              {maintenance?.state === 'in_progress' && (
                <MenuItem
                  sx={{ display: canChangeState ? 'flex' : 'none' }}
                  onClick={() => {
                    handleStateChange('planned');
                    setActionsMenuAnchor(null);
                  }}
                  sx={{ color: 'secondary.main' }}
                >
                  <ListItemIcon>
                    <ReplayIcon fontSize="small" sx={{ color: 'secondary.main' }} />
                  </ListItemIcon>
                  <ListItemText>{t('Back to planned')}</ListItemText>
                </MenuItem>
              )}
              {isDone && (
                <MenuItem
                  sx={{ display: canChangeState ? 'flex' : 'none' }}
                  onClick={() => {
                    handleStateChange('in_progress');
                    setActionsMenuAnchor(null);
                  }}
                  sx={{ color: 'secondary.main' }}
                >
                  <ListItemIcon>
                    <ReplayIcon fontSize="small" sx={{ color: 'secondary.main' }} />
                  </ListItemIcon>
                  <ListItemText>{t('Reopen')}</ListItemText>
                </MenuItem>
              )}
              {['quote', 'planned', 'in_progress', 'waiting', 'vehicle_in_workshop'].includes(maintenance?.state) && (
                <>
                  <Divider />
                  <MenuItem
                    sx={{ display: canChangeState ? 'flex' : 'none' }}
                    onClick={() => {
                      handleStateChange('cancelled');
                      setActionsMenuAnchor(null);
                    }}
                    sx={{ color: 'error.main' }}
                  >
                    <ListItemIcon>
                      <CancelIcon fontSize="small" sx={{ color: 'error.main' }} />
                    </ListItemIcon>
                    <ListItemText>{t('Cancel')}</ListItemText>
                  </MenuItem>
                </>
              )}
            </Menu>

            {/* Request Approval Button - visible when items pending confirmation */}
            {countPendingConfirmation() > 0 && canRequestApproval && (
              <Button
                variant="outlined"
                startIcon={
                  <Badge badgeContent={countPendingConfirmation()} color="warning">
                    <HourglassEmptyIcon />
                  </Badge>
                }
                onClick={() => setExtraWorkDialogOpen(true)}
                sx={{
                  borderColor: 'warning.main',
                  color: 'warning.main',
                  px: 2,
                  py: 1.25,
                  borderRadius: '10px',
                  fontWeight: 500,
                  fontFamily: "'Plus Jakarta Sans', sans-serif",
                  flex: { xs: 1, md: 'none' },
                  '&:hover': {
                    borderColor: 'warning.dark',
                    bgcolor: 'warning.lighter',
                  },
                }}
              >
                {t('Request approval')}
              </Button>
            )}

            {/* Next State Button - Always visible when available */}
            {nextStateButton && canChangeState && (
              <Button
                variant="contained"
                data-testid="maintenance-next-state"
                startIcon={nextStateButton.icon}
                onClick={() => handleStateChange(nextStateButton.state)}
                sx={{
                  bgcolor: 'secondary.main',
                  color: 'white',
                  px: 2.5,
                  py: 1.25,
                  borderRadius: '10px',
                  fontWeight: 600,
                  fontFamily: "'Plus Jakarta Sans', sans-serif",
                  boxShadow: '0 4px 12px rgba(49, 130, 206, 0.3)',
                  flex: { xs: '1 1 100%', md: 'none' },
                  '&:hover': {
                    bgcolor: 'secondary.light',
                    boxShadow: '0 6px 16px rgba(49, 130, 206, 0.4)',
                  },
                }}
              >
                {nextStateButton.label}
              </Button>
            )}
          </Box>
        </Box>

        {/* Bottom Row - Vehicle specs & meta */}
        <Box
          sx={{
            p: { xs: 2, md: '18px 24px' },
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: 'space-between',
            alignItems: { xs: 'flex-start', md: 'center' },
            gap: 2,
          }}
        >
          {/* Specs Tags + Quota */}
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
            {maintenance?.vehicle?.engine_code && (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.75,
                  bgcolor: 'background.paper',
                  px: 1.5,
                  py: 0.75,
                  borderRadius: '8px',
                  fontSize: '13px',
                  color: 'text.secondary',
                  fontWeight: 500,
                  border: '1px solid',
                  borderColor: 'divider',
                }}
              >
                <SettingsIcon sx={{ fontSize: 14 }} />
                {maintenance.vehicle.engine_code}
              </Box>
            )}
            {maintenance?.vehicle?.fuel && (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.75,
                  bgcolor: 'background.paper',
                  px: 1.5,
                  py: 0.75,
                  borderRadius: '8px',
                  fontSize: '13px',
                  color: 'text.secondary',
                  fontWeight: 500,
                  border: '1px solid',
                  borderColor: 'divider',
                }}
              >
                <LocalGasStationIcon sx={{ fontSize: 14 }} />
                {maintenance.vehicle.fuel}
              </Box>
            )}
            {(maintenance?.vehicle?.power_kw || maintenance?.vehicle?.power_hp) && (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.75,
                  bgcolor: 'background.paper',
                  px: 1.5,
                  py: 0.75,
                  borderRadius: '8px',
                  fontSize: '13px',
                  color: 'text.secondary',
                  fontWeight: 500,
                  border: '1px solid',
                  borderColor: 'divider',
                }}
              >
                <SpeedIcon sx={{ fontSize: 14 }} />
                {maintenance.vehicle.power_kw && `${maintenance.vehicle.power_kw} kW`}
                {maintenance.vehicle.power_kw && maintenance.vehicle.power_hp && ' / '}
                {maintenance.vehicle.power_hp && `${maintenance.vehicle.power_hp} hp`}
              </Box>
            )}
            {/* Vehicle Lookup Button - shown if data not fetched and has valid Finnish reg */}
            {(() => {
              const vehicle = maintenance?.vehicle;
              if (!vehicle?.registration_number) return null;
              if (!isFinnishRegistrationNumber(vehicle.registration_number)) return null;
              // Hide if vehicle data already exists
              const hasData = vehicle.manufacturer || vehicle.model || vehicle.vin;
              if (hasData) return null;
              if (vehicle.manually_edited) return null;

              return (
                <Tooltip title={t('vehicleLookup.button')}>
                  <Box
                    onClick={() => !vehicleLookupLoading && handleVehicleLookup()}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 0.75,
                      bgcolor: 'rgba(49, 130, 206, 0.05)',
                      px: 1.5,
                      py: 0.75,
                      borderRadius: '8px',
                      fontSize: '13px',
                      color: 'secondary.main',
                      fontWeight: 500,
                      border: '1px solid',
                      borderColor: 'secondary.light',
                      cursor: vehicleLookupLoading ? 'default' : 'pointer',
                      transition: 'all 0.15s',
                      '&:hover': vehicleLookupLoading ? {} : {
                        borderColor: 'secondary.main',
                        bgcolor: 'rgba(49, 130, 206, 0.1)',
                      },
                    }}
                  >
                    {vehicleLookupLoading
                      ? <CircularProgress size={14} color="secondary" />
                      : <SearchIcon sx={{ fontSize: 14 }} />
                    }
                    {t('vehicleLookup.button')}
                  </Box>
                </Tooltip>
              );
            })()}
            {/* Odometer / Hour Meter Reading */}
            {(() => {
              const hasKm = maintenance?.vehicle_latest_odometer;
              const hasHours = maintenance?.vehicle_latest_hour_meter;
              const hasReading = hasKm || hasHours;
              const hasReadingForThisMaintenance = maintenance?.odometer_readings?.length > 0;
              const isStale = hasReading && !hasReadingForThisMaintenance;

              const readingParts = [];
              if (hasKm) readingParts.push(`${maintenance.vehicle_latest_odometer.toLocaleString('fi-FI')} km`);
              if (hasHours) readingParts.push(`${maintenance.vehicle_latest_hour_meter.toLocaleString('fi-FI')} h`);

              return (
                <Tooltip title={isStale ? t('odometer.staleTooltip') : t('odometer.clickToRecord')}>
                  <Box
                    onClick={() => setOdometerDialogOpen(true)}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 0.75,
                      bgcolor: isStale
                        ? 'rgba(237, 137, 54, 0.1)'
                        : hasReading
                          ? 'background.paper'
                          : 'rgba(49, 130, 206, 0.05)',
                      px: 1.5,
                      py: 0.75,
                      borderRadius: '8px',
                      fontSize: '13px',
                      color: isStale
                        ? 'warning.dark'
                        : hasReading
                          ? 'text.secondary'
                          : 'secondary.main',
                      fontWeight: 500,
                      border: '1px solid',
                      borderColor: isStale
                        ? 'warning.main'
                        : hasReading
                          ? 'divider'
                          : 'secondary.light',
                      cursor: 'pointer',
                      transition: 'all 0.15s',
                      '&:hover': {
                        borderColor: isStale ? 'warning.dark' : 'secondary.main',
                        bgcolor: isStale ? 'rgba(237, 137, 54, 0.15)' : 'rgba(49, 130, 206, 0.1)',
                      },
                    }}
                  >
                    <SpeedIcon sx={{ fontSize: 14 }} />
                    {hasReading
                      ? readingParts.join(' / ')
                      : t('odometer.recordReading')}
                  </Box>
                </Tooltip>
              );
            })()}
            {maintenance?.vehicle?.id && (
              <Tooltip title={t('vehicles.maintenanceHistory')}>
                <Box
                  onClick={() => { setVehicleHistoryInitialTab(1); setVehicleHistoryDialogOpen(true); }}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.75,
                    bgcolor: 'rgba(49, 130, 206, 0.05)',
                    px: 1.5,
                    py: 0.75,
                    borderRadius: '8px',
                    fontSize: '13px',
                    color: 'secondary.main',
                    fontWeight: 500,
                    border: '1px solid',
                    borderColor: 'secondary.light',
                    cursor: 'pointer',
                    transition: 'all 0.15s',
                    '&:hover': {
                      borderColor: 'secondary.main',
                      bgcolor: 'rgba(49, 130, 206, 0.1)',
                    },
                  }}
                >
                  <HistoryIcon sx={{ fontSize: 14 }} />
                  {t('vehicles.maintenanceHistory')}
                </Box>
              </Tooltip>
            )}
          </Box>
          {/* Vehicle lookup quota indicator */}
          {(() => {
            const vehicle = maintenance?.vehicle;
            if (!vehicle?.registration_number) return null;
            if (!isFinnishRegistrationNumber(vehicle.registration_number)) return null;
            const hasData = vehicle.manufacturer || vehicle.model || vehicle.vin;
            if (hasData) return null;
            if (vehicle.manually_edited) return null;
            if (!vehicleLookupQuota) return null;

            if (vehicleLookupQuota.vehicle_data_provider === 'rekisterinumeroapi') {
              return (
                <Box sx={{ display: 'flex', alignItems: 'center', mt: 0.5 }}>
                  <Typography variant="caption" color="success.main">
                    {t('vehicleLookup.fallbackProviderShort')}
                  </Typography>
                </Box>
              );
            }

            return (
              <Box sx={{ display: 'flex', alignItems: 'center', mt: 0.5 }}>
                <Typography
                  variant="caption"
                  color="text.secondary"
                >
                  {t('vehicleLookup.quotaRemaining', {
                    remaining: Math.max(0, vehicleLookupQuota.remaining_lookups),
                    total: vehicleLookupQuota.included_lookups,
                  })}
                </Typography>
                <HelpButton text={t('vehicleLookup.quotaHelp')} size={16} />
              </Box>
            );
          })()}
          </Box>

          {/* Meta info */}
          <Box
            sx={{
              display: 'flex',
              gap: { xs: 2, md: 2.5 },
              fontSize: '13px',
              color: 'text.secondary',
              flexWrap: 'wrap',
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
              <CalendarTodayIcon sx={{ fontSize: 14 }} />
              {t('Created at')} {formatDate(maintenance?.created_at)?.split(' ')[0]}
            </Box>
          </Box>
        </Box>
      </Paper>

      {/* Work Order Timeline */}
      {maintenance?.id && (
        <WorkOrderTimeline maintenanceId={maintenance.id} maintenanceState={maintenance.state} />
      )}

      {/* Problem Description Section */}
      <Paper
        elevation={0}
        data-testid="maintenance-description"
        onClick={isDone || !canEdit ? undefined : handleOpenDescriptionEdit}
        sx={{
          mb: 3,
          border: '1px solid',
          borderColor: maintenance?.description ? 'divider' : (isDone ? 'divider' : 'grey.300'),
          borderStyle: maintenance?.description ? 'solid' : 'dashed',
          cursor: isDone ? 'default' : 'pointer',
          transition: 'all 0.15s',
          '&:hover': isDone ? {} : {
            borderColor: 'secondary.main',
            bgcolor: 'action.hover',
          },
        }}
      >
        <Box sx={{ p: 2.5, display: 'flex', alignItems: 'flex-start', gap: 2 }}>
          {/* Icon */}
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: '10px',
              bgcolor: maintenance?.description ? 'rgba(237, 137, 54, 0.1)' : 'action.hover',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            <ReportProblemOutlinedIcon
              sx={{
                fontSize: 20,
                color: maintenance?.description ? 'warning.main' : 'text.disabled',
              }}
            />
          </Box>

          {/* Content */}
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5, flexWrap: 'wrap' }}>
              <Typography
                sx={{
                  fontSize: '13px',
                  fontWeight: 600,
                  color: 'text.secondary',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                }}
              >
                {t('Problem description')}
              </Typography>
              {!isDone && maintenance?.description && (
                <EditIcon sx={{ fontSize: 14, color: 'text.disabled' }} />
              )}
              {maintenance?.description && (
                <Chip
                  label={maintenance.show_description_to_customer
                    ? t('Visible to customer')
                    : t('Not visible to customer')}
                  size="small"
                  color={maintenance.show_description_to_customer ? 'success' : 'default'}
                  variant="outlined"
                  sx={{ fontSize: '11px', height: 22 }}
                />
              )}
              {hasDescriptionDraft && !isDone && (
                <Chip
                  label={t('Unsaved draft')}
                  size="small"
                  color="warning"
                  sx={{ fontSize: '11px', height: 22 }}
                />
              )}
            </Box>
            {maintenance?.description ? (
              <Typography
                sx={{
                  fontSize: '15px',
                  color: 'text.primary',
                  lineHeight: 1.5,
                  whiteSpace: 'pre-wrap',
                }}
              >
                {maintenance.description}
              </Typography>
            ) : (
              <Typography
                sx={{
                  fontSize: '14px',
                  color: 'text.disabled',
                  fontStyle: 'italic',
                }}
              >
                {isDone ? t('No problem description') : t('Click to add problem description')}
              </Typography>
            )}
          </Box>
        </Box>
      </Paper>

      {/* Customer's and vehicle's internal notes: workshop-only, never on prints or to the customer */}
      <InternalNotesAlert
        customerNote={maintenance?.customer?.internal_note}
        vehicleNote={maintenance?.vehicle?.internal_note}
        sx={{ mb: 3 }}
      />

      {/* Vehicle's service info (e.g. wheel bolt torque); edited from the vehicle, also printed */}
      <VehicleServiceInfoBox serviceInfo={maintenance?.vehicle?.service_info} sx={{ mb: 3 }} />

      {/* Work Order Confirmation Status */}
      {maintenance?.confirmation_status === 'pending' && (
        <Alert
          severity="warning"
          sx={{ mb: 3, borderRadius: '12px' }}
          action={
            <Typography variant="body2" color="text.secondary" sx={{ mr: 1, whiteSpace: 'nowrap' }}>
              {maintenance.confirmation_expires_at && (
                <>{t('confirmation.expires')}: {new Date(maintenance.confirmation_expires_at).toLocaleDateString('fi-FI')}</>
              )}
            </Typography>
          }
        >
          <Typography sx={{ fontWeight: 600 }}>
            {maintenance.confirmation_quote_id
              ? t('confirmation.awaitingQuoteAcceptance')
              : t('confirmation.awaitingConfirmation')}
          </Typography>
          {maintenance.confirmation_requested_at && (
            <Typography variant="body2" color="text.secondary">
              {t('confirmation.confirmationRequested')}: {new Date(maintenance.confirmation_requested_at).toLocaleDateString('fi-FI')}
            </Typography>
          )}
        </Alert>
      )}
      {maintenance?.confirmation_status === 'confirmed' && (
        <Alert
          severity="success"
          sx={{ mb: 3, borderRadius: '12px' }}
          action={
            maintenance.confirmation_quote_id && maintenance.state === 'quote' && canChangeState ? (
              <Button size="small" color="success" onClick={() => handleStateChange('planned')}>
                {t('Convert to maintenance')}
              </Button>
            ) : null
          }
        >
          <Typography sx={{ fontWeight: 600 }}>
            {maintenance.confirmation_quote_id
              ? t('confirmation.customerAcceptedQuote')
              : t('confirmation.customerConfirmed')}
          </Typography>
          {maintenance.confirmation_responded_at && (
            <Typography variant="body2" color="text.secondary">
              {new Date(maintenance.confirmation_responded_at).toLocaleDateString('fi-FI')}
            </Typography>
          )}
          {maintenance.confirmation_customer_note && (
            <Typography variant="body2" sx={{ mt: 0.5, fontStyle: 'italic' }}>
              {t('confirmation.customerNote')}: {maintenance.confirmation_customer_note}
            </Typography>
          )}
        </Alert>
      )}
      {maintenance?.confirmation_status === 'declined' && (
        <Alert
          severity="error"
          sx={{ mb: 3, borderRadius: '12px' }}
          action={
            <Button
              size="small"
              color="error"
              onClick={() =>
                maintenance.confirmation_quote_id ? setOfferDialogOpen(true) : setConfirmationDialogOpen(true)
              }
            >
              {maintenance.confirmation_quote_id ? t('Resend quote') : t('confirmation.reRequestConfirmation')}
            </Button>
          }
        >
          <Typography sx={{ fontWeight: 600 }}>
            {maintenance.confirmation_quote_id
              ? t('confirmation.customerDeclinedQuote')
              : t('confirmation.customerDeclined')}
          </Typography>
          {maintenance.confirmation_responded_at && (
            <Typography variant="body2" color="text.secondary">
              {new Date(maintenance.confirmation_responded_at).toLocaleDateString('fi-FI')}
            </Typography>
          )}
          {maintenance.confirmation_customer_note && (
            <Typography variant="body2" sx={{ mt: 0.5, fontStyle: 'italic' }}>
              {t('confirmation.customerNote')}: {maintenance.confirmation_customer_note}
            </Typography>
          )}
        </Alert>
      )}

      {/* €0 parts warning — catches any part with zero price regardless of source */}
      {(() => {
        const zeroPriceParts = (maintenance?.parts || []).filter(p =>
          p.unit_price === 0 || p.unit_price === '0' || p.unit_price === '0.00' ||
          parseFloat(p.unit_price || 0) === 0
        );
        return zeroPriceParts.length > 0 ? (
          <Alert severity="error" sx={{ mb: 3, borderRadius: '12px' }}>
            <Typography sx={{ fontWeight: 600 }}>
              {t('oem.zeroPricePartsWarning', { count: zeroPriceParts.length, defaultValue: `${zeroPriceParts.length} osaa ilman hintaa — täydennä ennen laskutusta` })}
            </Typography>
          </Alert>
        ) : null;
      })()}

      {/* Tarjousautomaatti estimate lines: placeholder parts and jobs still without a price.
          Nothing blocks invoicing; this is the reminder to replace them first. */}
      {(() => {
        const estimateLines = (maintenance?.parts || []).filter((p) => p.is_estimate).length
          + (maintenance?.jobs || []).filter((j) => j.is_estimate).length;
        return estimateLines > 0 ? (
          <Alert severity="warning" sx={{ mb: 3, borderRadius: '12px' }} data-testid="quote-machine-estimate-banner">
            <Typography sx={{ fontWeight: 600 }}>
              {t('quoteMachine.estimateLinesWarning', { count: estimateLines })}
            </Typography>
          </Alert>
        ) : null;
      })()}

      {/* Extra Work Request Response Banners */}
      {maintenance?.extra_work_requests?.filter(ewr => ewr.items_count > 0).map((ewr) => (
        <Alert
          key={ewr.id}
          severity={ewr.status === 'approved' ? 'success' : 'error'}
          sx={{ mb: 3, borderRadius: '12px' }}
          action={
            ewr.status === 'denied' ? (
              <Button
                size="small"
                color="error"
                onClick={() => setExtraWorkDialogOpen(true)}
              >
                {t('confirmation.reRequestConfirmation')}
              </Button>
            ) : undefined
          }
        >
          <Typography sx={{ fontWeight: 600 }}>
            {ewr.status === 'approved' ? t('Extra work approved') : t('Extra work denied')}
          </Typography>
          {ewr.responded_at && (
            <Typography variant="body2" color="text.secondary">
              {new Date(ewr.responded_at).toLocaleDateString('fi-FI')}
            </Typography>
          )}
          {ewr.items_summary?.length > 0 && (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              {ewr.items_summary.slice(0, 4).join(', ')}
              {ewr.items_summary.length > 4 && ` +${ewr.items_summary.length - 4}`}
              {ewr.total && ` (${formatPrice(ewr.total)} €)`}
            </Typography>
          )}
          {ewr.customer_response_note && (
            <Typography variant="body2" sx={{ mt: 0.5, fontStyle: 'italic' }}>
              {t('confirmation.customerNote')}: {ewr.customer_response_note}
            </Typography>
          )}
        </Alert>
      ))}

      {/* People Section - Customer & Mechanics side by side */}
      <Grid container spacing={2} sx={{ mb: 3 }}>
        {/* Customer Card */}
        <Grid item xs={12} md={6}>
          <Paper
            elevation={0}
            sx={{
              height: '100%',
              border: '1px solid',
              borderColor: maintenance?.customer ? 'divider' : (isDone ? 'divider' : 'warning.main'),
              borderStyle: maintenance?.customer ? 'solid' : 'dashed',
            }}
          >
            <CardHeader
              title={t('Customer')}
              icon={<PersonIcon sx={{ fontSize: 20 }} />}
              action={!isDone && canEdit && maintenance?.customer && (
                <IconButton
                  size="small"
                  data-testid="customer-edit-button"
                  onClick={(e) => { e.stopPropagation(); setCustomerEditDialogOpen(true); }}
                  sx={{ color: 'text.disabled', '&:hover': { color: 'primary.main' } }}
                >
                  <EditIcon sx={{ fontSize: 18 }} />
                </IconButton>
              )}
            />
            <Box
              onClick={isDone ? undefined : () => setCustomerModalOpen(true)}
              sx={{
                p: 2.5,
                cursor: isDone ? 'default' : 'pointer',
                transition: 'background-color 0.15s',
                '&:hover': isDone ? {} : { bgcolor: 'action.hover' },
              }}
            >
            {maintenance?.customer ? (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.75 }}>
                {/* Customer Avatar */}
                <Box
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: '50%',
                    background: maintenance.customer.type === 'company'
                      ? 'linear-gradient(135deg, #3182CE 0%, #2563EB 100%)'
                      : 'linear-gradient(135deg, #8B5CF6 0%, #7C3AED 100%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'white',
                    fontSize: '16px',
                    fontWeight: 600,
                    flexShrink: 0,
                    boxShadow: maintenance.customer.type === 'company'
                      ? '0 4px 12px rgba(49, 130, 206, 0.3)'
                      : '0 4px 12px rgba(139, 92, 246, 0.3)',
                  }}
                >
                  {maintenance.customer.type === 'company' ? (
                    <BusinessIcon sx={{ fontSize: 22 }} />
                  ) : (
                    maintenance.customer.name?.split(' ').map(n => n[0]).join('').substring(0, 2)
                  )}
                </Box>

                {/* Customer Details */}
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.75 }}>
                    <Typography
                      sx={{
                        fontSize: '16px',
                        fontWeight: 600,
                        color: 'text.primary',
                        fontFamily: "'Plus Jakarta Sans', sans-serif",
                      }}
                    >
                      {maintenance.customer.name}
                    </Typography>
                    {maintenance.customer.type === 'company' && (
                      <Typography
                        sx={{
                          fontSize: '11px',
                          color: 'text.secondary',
                          bgcolor: 'action.hover',
                          px: 0.75,
                          py: 0.25,
                          borderRadius: '4px',
                        }}
                      >
                        {t('Company')}
                      </Typography>
                    )}
                  </Box>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                    {maintenance.customer.phone && (
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'text.secondary', fontSize: '13px' }}>
                        <PhoneIcon sx={{ fontSize: 14, color: 'text.disabled' }} />
                        {maintenance.customer.phone}
                      </Box>
                    )}
                    {maintenance.customer.email && (
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1,
                          color: 'text.secondary',
                          fontSize: '13px',
                          overflow: 'hidden',
                        }}
                      >
                        <EmailIcon sx={{ fontSize: 14, color: 'text.disabled', flexShrink: 0 }} />
                        <Typography
                          sx={{
                            fontSize: '13px',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {maintenance.customer.email}
                        </Typography>
                      </Box>
                    )}
                  </Box>
                </Box>
              </Box>
            ) : (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.75 }}>
                <Box
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: '50%',
                    bgcolor: isDone ? 'action.hover' : 'rgba(237, 137, 54, 0.1)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                  }}
                >
                  <PeopleIcon sx={{ fontSize: 22, color: isDone ? 'text.disabled' : 'warning.main' }} />
                </Box>
                <Box>
                  <Typography
                    sx={{
                      fontSize: '15px',
                      fontWeight: 500,
                      color: isDone ? 'text.disabled' : 'warning.main',
                      fontFamily: "'Plus Jakarta Sans', sans-serif",
                    }}
                  >
                    {t('No customer assigned')}
                  </Typography>
                  {!isDone && (
                    <Typography sx={{ fontSize: '13px', color: 'text.secondary' }}>
                      {t('Click to assign a customer')}
                    </Typography>
                  )}
                </Box>
              </Box>
            )}
            </Box>

            {/* Billing Customer sub-section */}
            {(maintenance?.billing_customer || (!isDone && maintenance?.customer)) && (
              <Box
                onClick={isDone ? undefined : (e) => { e.stopPropagation(); setBillingCustomerModalOpen(true); }}
                sx={{
                  px: 2.5,
                  py: 1.5,
                  borderTop: '1px solid',
                  borderColor: 'divider',
                  cursor: isDone ? 'default' : 'pointer',
                  transition: 'background-color 0.15s',
                  '&:hover': isDone ? {} : { bgcolor: 'action.hover' },
                }}
              >
                {maintenance?.billing_customer ? (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <ReceiptLongIcon sx={{ fontSize: 16, color: 'success.main' }} />
                    <Typography sx={{ fontSize: '13px', color: 'text.secondary' }}>
                      {t('Invoice recipient')}:
                    </Typography>
                    <Typography sx={{ fontSize: '13px', fontWeight: 600, color: 'text.primary' }}>
                      {maintenance.billing_customer.name}
                    </Typography>
                    {!isDone && (
                      <EditIcon sx={{ fontSize: 14, color: 'text.disabled', ml: 'auto' }} />
                    )}
                  </Box>
                ) : (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <ReceiptLongIcon sx={{ fontSize: 16, color: 'text.disabled' }} />
                    <Typography sx={{ fontSize: '13px', color: 'text.disabled' }}>
                      {t('Set billing customer / insurance company')}
                    </Typography>
                  </Box>
                )}
              </Box>
            )}

            {/* Insurance toggle - shown when billing_customer is set */}
            {maintenance?.billing_customer && (
              <Box sx={{ px: 2.5, py: 1.5, borderTop: '1px solid', borderColor: 'divider' }} onClick={(e) => e.stopPropagation()}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={!!maintenance.billing_customer_is_insurance}
                      onChange={(e) => {
                        const newValue = e.target.checked;
                        const oldValue = maintenance.billing_customer_is_insurance;
                        setMaintenance(prev => ({ ...prev, billing_customer_is_insurance: newValue }));
                        axios.patch(`/api/maintenances/${maintenance.id}/update_insurance_details/`, {
                          billing_customer_is_insurance: newValue,
                        }).then(res => {
                          setMaintenance(prev => ({ ...prev, ...res.data }));
                        }).catch(() => {
                          setMaintenance(prev => ({ ...prev, billing_customer_is_insurance: oldValue }));
                          setSaveErrorSnackbar(true);
                        });
                      }}
                      disabled={isDone}
                      size="small"
                    />
                  }
                  label={<Typography sx={{ fontSize: '13px', color: 'text.secondary' }}>{t('Billing customer is insurance company')}</Typography>}
                />
              </Box>
            )}

            {/* Omavastuu for a non-insurance billing customer (insurance mode keeps it in Vakuutustiedot) */}
            {maintenance?.billing_customer && !maintenance?.billing_customer_is_insurance && (
              <Box
                data-testid="deductible-row"
                onClick={isDone ? undefined : (e) => { e.stopPropagation(); setDeductibleDialogOpen(true); }}
                sx={{
                  px: 2.5,
                  py: 1.5,
                  borderTop: '1px solid',
                  borderColor: 'divider',
                  cursor: isDone ? 'default' : 'pointer',
                  transition: 'background-color 0.15s',
                  '&:hover': isDone ? {} : { bgcolor: 'action.hover' },
                }}
              >
                {parseFloat(maintenance.deductible_amount) > 0 ? (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <ReceiptLongIcon sx={{ fontSize: 16, color: 'warning.main' }} />
                    <Typography sx={{ fontSize: '13px', color: 'text.secondary' }}>
                      {t('Deductible')}:
                    </Typography>
                    <Typography sx={{ fontSize: '13px', fontWeight: 600, color: 'text.primary' }}>
                      {formatPrice(maintenance.deductible_amount)} €
                    </Typography>
                    {!isDone && (
                      <EditIcon sx={{ fontSize: 14, color: 'text.disabled', ml: 'auto' }} />
                    )}
                  </Box>
                ) : (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <ReceiptLongIcon sx={{ fontSize: 16, color: 'text.disabled' }} />
                    <Typography sx={{ fontSize: '13px', color: 'text.disabled' }}>
                      {t('Set deductible (optional)')}
                    </Typography>
                  </Box>
                )}
              </Box>
            )}

            {/* ALV-Yritys toggle - shown when insurance mode is active */}
            {maintenance?.billing_customer && maintenance?.billing_customer_is_insurance && (
              <Box sx={{ px: 2.5, py: 1, borderTop: '1px solid', borderColor: 'divider' }} onClick={(e) => e.stopPropagation()}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={!!maintenance.insurance_vat_deductible}
                      onChange={(e) => {
                        const newValue = e.target.checked;
                        const oldValue = maintenance.insurance_vat_deductible;
                        setMaintenance(prev => ({ ...prev, insurance_vat_deductible: newValue }));
                        axios.patch(`/api/maintenances/${maintenance.id}/update_insurance_details/`, {
                          insurance_vat_deductible: newValue,
                        }).then(res => {
                          setMaintenance(prev => ({ ...prev, ...res.data }));
                        }).catch(() => {
                          setMaintenance(prev => ({ ...prev, insurance_vat_deductible: oldValue }));
                          setSaveErrorSnackbar(true);
                        });
                      }}
                      disabled={isDone}
                      size="small"
                    />
                  }
                  label={
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                      <Typography sx={{ fontSize: '13px', color: 'text.secondary' }}>{t('VAT deductible company car')}</Typography>
                      <HelpButton text={t('vatDeductibleHelp')} size={16} />
                    </Box>
                  }
                />
                {maintenance.insurance_vat_deductible && (
                  <TextField
                    select
                    size="small"
                    fullWidth
                    label={t('VAT deduction method')}
                    value={maintenance.insurance_vat_method || 'full'}
                    onChange={(e) => {
                      const newValue = e.target.value;
                      const oldValue = maintenance.insurance_vat_method;
                      setMaintenance(prev => ({ ...prev, insurance_vat_method: newValue }));
                      axios.patch(`/api/maintenances/${maintenance.id}/update_insurance_details/`, {
                        insurance_vat_method: newValue,
                      }).then(res => {
                        setMaintenance(prev => ({ ...prev, ...res.data }));
                      }).catch(() => {
                        setMaintenance(prev => ({ ...prev, insurance_vat_method: oldValue }));
                        setSaveErrorSnackbar(true);
                      });
                    }}
                    disabled={isDone}
                    sx={{ mt: 1, mb: 0.5 }}
                    inputProps={{ 'data-testid': 'insurance-vat-method' }}
                    SelectProps={{ SelectDisplayProps: { 'data-testid': 'insurance-vat-method-select' } }}
                  >
                    <MenuItem value="full">{t('vatMethod.full')}</MenuItem>
                    <MenuItem value="after_deductible">{t('vatMethod.after_deductible')}</MenuItem>
                  </TextField>
                )}
                {maintenance.insurance_vat_deductible && maintenance.customer?.type !== 'company' && !maintenance.vat_invoice_customer && (
                  <Alert severity="warning" sx={{ mt: 1, fontSize: '12px', '& .MuiAlert-message': { fontSize: '12px' } }}>
                    {t('vatDeductibleCompanyWarning')}
                  </Alert>
                )}
              </Box>
            )}

            {/* Leasing company (VAT payer) selector — optional three-way split, only in ALV mode */}
            {maintenance?.billing_customer && maintenance?.billing_customer_is_insurance && maintenance?.insurance_vat_deductible && (
              <Box
                onClick={isDone ? undefined : (e) => { e.stopPropagation(); setLeasingCustomerModalOpen(true); }}
                sx={{
                  px: 2.5,
                  py: 1.5,
                  borderTop: '1px solid',
                  borderColor: 'divider',
                  cursor: isDone ? 'default' : 'pointer',
                  transition: 'background-color 0.15s',
                  '&:hover': isDone ? {} : { bgcolor: 'action.hover' },
                }}
              >
                {maintenance?.vat_invoice_customer ? (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <ReceiptLongIcon sx={{ fontSize: 16, color: 'success.main' }} />
                    <Typography sx={{ fontSize: '13px', color: 'text.secondary' }}>
                      {t('Leasing company (pays VAT)')}:
                    </Typography>
                    <Typography sx={{ fontSize: '13px', fontWeight: 600, color: 'text.primary' }}>
                      {maintenance.vat_invoice_customer.name}
                    </Typography>
                    {!isDone && (
                      <EditIcon sx={{ fontSize: 14, color: 'text.disabled', ml: 'auto' }} />
                    )}
                  </Box>
                ) : (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <ReceiptLongIcon sx={{ fontSize: 16, color: 'text.disabled' }} />
                    <Typography sx={{ fontSize: '13px', color: 'text.disabled' }}>
                      {t('Set leasing company for VAT invoice (optional)')}
                    </Typography>
                  </Box>
                )}
              </Box>
            )}

            {/* Insurance seller site code info banner */}
            {maintenance?.billing_customer && maintenance?.billing_customer_is_insurance && !currentOrganization?.insurance_seller_site_code && (() => {
              const dismissed = (() => { try { return localStorage.getItem('verstaani_insurance_sitecode_banner_dismissed') === 'true'; } catch { return false; } })();
              if (dismissed) return null;
              return (
                <Box sx={{ px: 2.5, py: 1, borderTop: '1px solid', borderColor: 'divider' }} onClick={(e) => e.stopPropagation()}>
                  <Alert
                    severity="info"
                    sx={{ fontSize: '12px', '& .MuiAlert-message': { fontSize: '12px' } }}
                    onClose={() => {
                      try { localStorage.setItem('verstaani_insurance_sitecode_banner_dismissed', 'true'); } catch {}
                      setMaintenance(prev => ({ ...prev }));
                    }}
                  >
                    {t('insuranceSellerSiteCodeMissingBanner')}
                    <Box sx={{ mt: 1 }}>
                      <Button
                        color="inherit"
                        size="small"
                        variant="outlined"
                        sx={{ fontSize: '11px' }}
                        onClick={() => navigate('/settings?tab=invoicing')}
                      >
                        {t('Go to settings')}
                      </Button>
                    </Box>
                  </Alert>
                </Box>
              );
            })()}

            {/* Insurance Details sub-section - compact summary with edit dialog */}
            {maintenance?.billing_customer && maintenance?.billing_customer_is_insurance && (
              <Box
                sx={{
                  px: 2.5,
                  py: 1.5,
                  borderTop: '1px solid',
                  borderColor: 'divider',
                }}
                onClick={(e) => e.stopPropagation()}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5 }}>
                  <Typography sx={{ fontSize: '12px', color: 'text.secondary', fontWeight: 500 }}>
                    {t('Insurance details')}
                  </Typography>
                  {canEdit && (
                    <IconButton size="small" onClick={() => setInsuranceDialogOpen(true)} sx={{ p: 0.25 }}>
                      <EditIcon sx={{ fontSize: 14, color: 'text.disabled' }} />
                    </IconButton>
                  )}
                </Box>
                {/* Compact read-only summary */}
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 0.25,
                    cursor: 'pointer',
                    '&:hover': { bgcolor: 'action.hover' },
                    borderRadius: 1,
                    mx: -0.5,
                    px: 0.5,
                    py: 0.25,
                  }}
                  onClick={() => canEdit && setInsuranceDialogOpen(true)}
                >
                  {maintenance.insurance_claim_number ? (
                    <Typography sx={{ fontSize: '13px' }}>
                      <Box component="span" sx={{ color: 'text.secondary' }}>{t('Insurance claim number')}:</Box>{' '}
                      {maintenance.insurance_claim_number}
                    </Typography>
                  ) : (
                    <Typography sx={{ fontSize: '13px', color: 'text.disabled', fontStyle: 'italic' }}>
                      {t('Insurance claim number')}: —
                    </Typography>
                  )}
                  {maintenance.deductible_amount ? (
                    <Typography sx={{ fontSize: '13px' }}>
                      <Box component="span" sx={{ color: 'text.secondary' }}>{t('Deductible amount')}:</Box>{' '}
                      {formatQuantity(maintenance.deductible_amount)} €
                    </Typography>
                  ) : (
                    <Typography sx={{ fontSize: '13px', color: 'text.disabled', fontStyle: 'italic' }}>
                      {t('Deductible amount')}: —
                    </Typography>
                  )}
                  {maintenance.insurance_damage_date ? (
                    <Typography sx={{ fontSize: '13px' }}>
                      <Box component="span" sx={{ color: 'text.secondary' }}>{t('Damage date')}:</Box>{' '}
                      {formatDate(maintenance.insurance_damage_date)?.split(' ')[0]}
                    </Typography>
                  ) : (
                    <Typography sx={{ fontSize: '13px', color: 'text.disabled', fontStyle: 'italic' }}>
                      {t('Damage date')}: —
                    </Typography>
                  )}
                  {maintenance.insurance_damage_type && (
                    <Typography sx={{ fontSize: '13px' }}>
                      <Box component="span" sx={{ color: 'text.secondary' }}>{t('Damage type')}:</Box>{' '}
                      {t(`damageType.${maintenance.insurance_damage_type}`)}
                    </Typography>
                  )}
                  {maintenance.insurance_inspector_name && (
                    <Typography sx={{ fontSize: '13px' }}>
                      <Box component="span" sx={{ color: 'text.secondary' }}>{t('Inspector name')}:</Box>{' '}
                      {maintenance.insurance_inspector_name}
                    </Typography>
                  )}
                  {(maintenance.repair_start_date || maintenance.repair_end_date) && (
                    <Typography sx={{ fontSize: '13px' }}>
                      <Box component="span" sx={{ color: 'text.secondary' }}>{t('Repair dates')}:</Box>{' '}
                      {maintenance.repair_start_date ? formatDate(maintenance.repair_start_date)?.split(' ')[0] : '—'}
                      {' — '}
                      {maintenance.repair_end_date ? formatDate(maintenance.repair_end_date)?.split(' ')[0] : '—'}
                    </Typography>
                  )}
                  {maintenance.seisontakorvaus_total && (
                    <Typography sx={{ fontSize: '13px' }}>
                      <Box component="span" sx={{ color: 'text.secondary' }}>{t('Standstill compensation')}:</Box>{' '}
                      {maintenance.seisontakorvaus_days} {t('days')} × {formatQuantity(maintenance.seisontakorvaus_daily_rate)} €/{t('day')} = {formatQuantity(maintenance.seisontakorvaus_total)} €
                    </Typography>
                  )}
                </Box>
              </Box>
            )}

            {/* Insurance Details Edit Dialog */}
            <Dialog
              open={insuranceDialogOpen && !!maintenance}
              onClose={() => setInsuranceDialogOpen(false)}
              maxWidth="sm"
              fullWidth
            >
              <DialogTitle>{t('Insurance details')}</DialogTitle>
              <DialogContent>
                {maintenance && (
                  <Grid container spacing={2} sx={{ mt: 0 }}>
                    {/* Core fields */}
                    <Grid item xs={12} sm={6}>
                      <TextField
                        size="small"
                        label={t('Insurance claim number')}
                        value={maintenance.insurance_claim_number || ''}
                        onChange={(e) => setMaintenance(prev => ({ ...prev, insurance_claim_number: e.target.value }))}
                        onBlur={(e) => {
                          const newValue = e.target.value;
                          const oldValue = maintenance._original_insurance_claim_number ?? '';
                          if (newValue !== oldValue) {
                            axios.patch(`/api/maintenances/${maintenance.id}/update_insurance_details/`, {
                              insurance_claim_number: newValue,
                            }).then(res => {
                              setMaintenance(prev => ({
                                ...prev,
                                ...res.data,
                                _original_insurance_claim_number: res.data.insurance_claim_number,
                              }));
                            }).catch(() => {
                              setMaintenance(prev => ({ ...prev, insurance_claim_number: oldValue }));
                              setSaveErrorSnackbar(true);
                            });
                          }
                        }}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <DecimalField
                        size="small"
                        label={t('Deductible amount') + ' (€)'}
                        value={maintenance.deductible_amount ?? ''}
                        onChange={(val) => {
                          setMaintenance(prev => ({ ...prev, deductible_amount: val }));
                        }}
                        onBlur={() => {
                          const oldValue = maintenance._original_deductible_amount ?? '';
                          axios.patch(`/api/maintenances/${maintenance.id}/update_insurance_details/`, {
                            deductible_amount: maintenance.deductible_amount || null,
                          }).then(res => {
                            setMaintenance(prev => ({ ...prev, ...res.data, _original_deductible_amount: res.data.deductible_amount }));
                          }).catch(() => {
                            setMaintenance(prev => ({ ...prev, deductible_amount: oldValue }));
                            setSaveErrorSnackbar(true);
                          });
                        }}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fi}>
                        <DatePicker
                          label={t('Damage date')}
                          value={dateStringToDate(maintenance.insurance_damage_date)}
                          onChange={(newValue) => {
                            const newDateStr = dateToDateString(newValue) || null;
                            if (newValue && !newDateStr) return;
                            const oldValue = maintenance._original_insurance_damage_date ?? null;
                            setMaintenance(prev => ({ ...prev, insurance_damage_date: newDateStr }));
                            if (newDateStr !== oldValue) {
                              axios.patch(`/api/maintenances/${maintenance.id}/update_insurance_details/`, {
                                insurance_damage_date: newDateStr,
                              }).then(res => {
                                setMaintenance(prev => ({
                                  ...prev,
                                  ...res.data,
                                  _original_insurance_damage_date: res.data.insurance_damage_date,
                                }));
                              }).catch(() => {
                                setMaintenance(prev => ({ ...prev, insurance_damage_date: oldValue }));
                                setSaveErrorSnackbar(true);
                              });
                            }
                          }}
                          format="dd.MM.yyyy"
                          slotProps={{
                            textField: { size: 'small', fullWidth: true },
                          }}
                        />
                      </LocalizationProvider>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl size="small" fullWidth>
                        <InputLabel>{t('Damage type')}</InputLabel>
                        <Select
                          value={maintenance.insurance_damage_type || ''}
                          label={t('Damage type')}
                          onChange={(e) => {
                            const newValue = e.target.value;
                            setMaintenance(prev => ({ ...prev, insurance_damage_type: newValue }));
                            axios.patch(`/api/maintenances/${maintenance.id}/update_insurance_details/`, {
                              insurance_damage_type: newValue,
                            }).then(res => {
                              setMaintenance(prev => ({ ...prev, ...res.data }));
                            }).catch(() => {
                              setSaveErrorSnackbar(true);
                            });
                          }}
                        >
                          <MenuItem value="">{t('Not selected')}</MenuItem>
                          {DAMAGE_TYPES.map((value) => (
                            <MenuItem key={value} value={value}>
                              {t(`damageType.${value}`)}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        size="small"
                        label={t('Damage description')}
                        value={maintenance.insurance_damage_description || ''}
                        onChange={(e) => setMaintenance(prev => ({ ...prev, insurance_damage_description: e.target.value }))}
                        onBlur={(e) => {
                          const newValue = e.target.value;
                          const oldValue = maintenance._original_insurance_damage_description ?? '';
                          if (newValue !== oldValue) {
                            axios.patch(`/api/maintenances/${maintenance.id}/update_insurance_details/`, {
                              insurance_damage_description: newValue,
                            }).then(res => {
                              setMaintenance(prev => ({
                                ...prev,
                                ...res.data,
                                _original_insurance_damage_description: res.data.insurance_damage_description,
                              }));
                            }).catch(() => {
                              setMaintenance(prev => ({ ...prev, insurance_damage_description: oldValue }));
                              setSaveErrorSnackbar(true);
                            });
                          }
                        }}
                        multiline
                        minRows={2}
                        fullWidth
                      />
                    </Grid>

                    {/* Inspector details */}
                    <Grid item xs={12}>
                      <Typography variant="subtitle2" sx={{ color: 'text.secondary', mt: 1 }}>
                        {t('Inspector details')}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        size="small"
                        label={t('Inspector name')}
                        value={maintenance.insurance_inspector_name || ''}
                        onChange={(e) => setMaintenance(prev => ({ ...prev, insurance_inspector_name: e.target.value }))}
                        onBlur={(e) => {
                          const newValue = e.target.value;
                          const oldValue = maintenance._original_insurance_inspector_name ?? '';
                          if (newValue !== oldValue) {
                            axios.patch(`/api/maintenances/${maintenance.id}/update_insurance_details/`, {
                              insurance_inspector_name: newValue,
                            }).then(res => {
                              setMaintenance(prev => ({
                                ...prev,
                                ...res.data,
                                _original_insurance_inspector_name: res.data.insurance_inspector_name,
                              }));
                            }).catch(() => {
                              setMaintenance(prev => ({ ...prev, insurance_inspector_name: oldValue }));
                              setSaveErrorSnackbar(true);
                            });
                          }
                        }}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        size="small"
                        label={t('Inspector code')}
                        value={maintenance.insurance_inspector_code || ''}
                        onChange={(e) => setMaintenance(prev => ({ ...prev, insurance_inspector_code: e.target.value }))}
                        onBlur={(e) => {
                          const newValue = e.target.value;
                          const oldValue = maintenance._original_insurance_inspector_code ?? '';
                          if (newValue !== oldValue) {
                            axios.patch(`/api/maintenances/${maintenance.id}/update_insurance_details/`, {
                              insurance_inspector_code: newValue,
                            }).then(res => {
                              setMaintenance(prev => ({
                                ...prev,
                                ...res.data,
                                _original_insurance_inspector_code: res.data.insurance_inspector_code,
                              }));
                            }).catch(() => {
                              setMaintenance(prev => ({ ...prev, insurance_inspector_code: oldValue }));
                              setSaveErrorSnackbar(true);
                            });
                          }
                        }}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fi}>
                        <DatePicker
                          label={t('Inspection date')}
                          value={dateStringToDate(maintenance.insurance_inspection_date)}
                          onChange={(newValue) => {
                            const newDateStr = dateToDateString(newValue) || null;
                            if (newValue && !newDateStr) return;
                            const oldValue = maintenance._original_insurance_inspection_date ?? null;
                            setMaintenance(prev => ({ ...prev, insurance_inspection_date: newDateStr }));
                            if (newDateStr !== oldValue) {
                              axios.patch(`/api/maintenances/${maintenance.id}/update_insurance_details/`, {
                                insurance_inspection_date: newDateStr,
                              }).then(res => {
                                setMaintenance(prev => ({
                                  ...prev,
                                  ...res.data,
                                  _original_insurance_inspection_date: res.data.insurance_inspection_date,
                                }));
                              }).catch(() => {
                                setMaintenance(prev => ({ ...prev, insurance_inspection_date: oldValue }));
                                setSaveErrorSnackbar(true);
                              });
                            }
                          }}
                          format="dd.MM.yyyy"
                          slotProps={{
                            textField: { size: 'small', fullWidth: true },
                          }}
                        />
                      </LocalizationProvider>
                    </Grid>

                    {/* Repair dates */}
                    <Grid item xs={12}>
                      <Typography variant="subtitle2" sx={{ color: 'text.secondary', mt: 1 }}>
                        {t('Repair dates')}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fi}>
                        <DatePicker
                          label={t('Repair start date')}
                          value={dateStringToDate(maintenance.repair_start_date)}
                          onChange={(newValue) => {
                            const newDateStr = dateToDateString(newValue) || null;
                            if (newValue && !newDateStr) return;
                            const oldValue = maintenance._original_repair_start_date ?? null;
                            setMaintenance(prev => ({ ...prev, repair_start_date: newDateStr }));
                            if (newDateStr !== oldValue) {
                              axios.patch(`/api/maintenances/${maintenance.id}/update_insurance_details/`, {
                                repair_start_date: newDateStr,
                              }).then(res => {
                                setMaintenance(prev => ({
                                  ...prev,
                                  ...res.data,
                                  _original_repair_start_date: res.data.repair_start_date,
                                }));
                              }).catch(() => {
                                setMaintenance(prev => ({ ...prev, repair_start_date: oldValue }));
                                setSaveErrorSnackbar(true);
                              });
                            }
                          }}
                          format="dd.MM.yyyy"
                          slotProps={{
                            textField: { size: 'small', fullWidth: true },
                          }}
                        />
                      </LocalizationProvider>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fi}>
                        <DatePicker
                          label={t('Repair end date')}
                          value={dateStringToDate(maintenance.repair_end_date)}
                          onChange={(newValue) => {
                            const newDateStr = dateToDateString(newValue) || null;
                            if (newValue && !newDateStr) return;
                            const oldValue = maintenance._original_repair_end_date ?? null;
                            setMaintenance(prev => ({ ...prev, repair_end_date: newDateStr }));
                            if (newDateStr !== oldValue) {
                              axios.patch(`/api/maintenances/${maintenance.id}/update_insurance_details/`, {
                                repair_end_date: newDateStr,
                              }).then(res => {
                                setMaintenance(prev => ({
                                  ...prev,
                                  ...res.data,
                                  _original_repair_end_date: res.data.repair_end_date,
                                }));
                              }).catch(() => {
                                setMaintenance(prev => ({ ...prev, repair_end_date: oldValue }));
                                setSaveErrorSnackbar(true);
                              });
                            }
                          }}
                          format="dd.MM.yyyy"
                          slotProps={{
                            textField: { size: 'small', fullWidth: true },
                          }}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                )}
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setInsuranceDialogOpen(false)}>{t('Close')}</Button>
              </DialogActions>
            </Dialog>
          </Paper>
        </Grid>

        {/* Mechanics Card */}
        <Grid item xs={12} md={6}>
          <Paper
            elevation={0}
            sx={{
              height: '100%',
              border: '1px solid',
              borderColor: 'divider',
            }}
          >
            <CardHeader
              title={t('Mechanics')}
              icon={<EngineeringIcon sx={{ fontSize: 20 }} />}
              action={!isDone && (
                <Button
                  variant="outlined"
                  startIcon={<AddIcon />}
                  size="small"
                  onClick={() => setEmployeeModalOpen(true)}
                  sx={{
                    borderColor: 'divider',
                    color: 'secondary.main',
                    borderRadius: '8px',
                    fontWeight: 500,
                    fontFamily: "'Plus Jakarta Sans', sans-serif",
                    '&:hover': {
                      borderColor: 'secondary.main',
                      bgcolor: 'transparent',
                    },
                  }}
                >
                  {t('Add')}
                </Button>
              )}
            />
            <Box sx={{ p: 2.5 }}>
            {maintenance?.employees && maintenance.employees.length > 0 ? (
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                {maintenance.employees.map((employee, index) => (
                  <Box
                    key={employee.id}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1.5,
                    }}
                  >
                    {/* Employee Avatar */}
                    <Box
                      sx={{
                        width: 40,
                        height: 40,
                        borderRadius: '50%',
                        bgcolor: 'rgba(49, 130, 206, 0.1)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'secondary.main',
                        fontSize: '14px',
                        fontWeight: 600,
                        flexShrink: 0,
                      }}
                    >
                      {employee.name?.split(' ').map(n => n[0]).join('').substring(0, 2)}
                    </Box>
                    <Box sx={{ flex: 1 }}>
                      <Typography
                        sx={{
                          fontSize: '14px',
                          fontWeight: 500,
                          color: 'text.primary',
                        }}
                      >
                        {employee.name}
                      </Typography>
                      {(employee.title || employee.role) && (
                        <Typography
                          sx={{
                            fontSize: '12px',
                            color: 'text.disabled',
                          }}
                        >
                          {employee.title || t(`role_${employee.role || 'employee'}`)}
                        </Typography>
                      )}
                    </Box>
                    {employee.is_primary && maintenance.employees.length > 1 && (
                      <Typography
                        sx={{
                          fontSize: '11px',
                          fontWeight: 600,
                          color: 'secondary.main',
                          bgcolor: 'rgba(49, 130, 206, 0.1)',
                          px: 1,
                          py: 0.25,
                          borderRadius: '4px',
                        }}
                      >
                        {t('Lead')}
                      </Typography>
                    )}
                  </Box>
                ))}
              </Box>
            ) : (
              <Box
                onClick={isDone ? undefined : () => setEmployeeModalOpen(true)}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1.75,
                  cursor: isDone ? 'default' : 'pointer',
                  p: 1,
                  mx: -1,
                  borderRadius: '8px',
                  transition: 'background-color 0.15s',
                  '&:hover': isDone ? {} : { bgcolor: 'action.hover' },
                }}
              >
                <Box
                  sx={{
                    width: 40,
                    height: 40,
                    borderRadius: '50%',
                    bgcolor: 'action.hover',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                  }}
                >
                  <EngineeringIcon sx={{ fontSize: 20, color: 'text.disabled' }} />
                </Box>
                <Typography
                  sx={{
                    fontSize: '14px',
                    color: 'text.disabled',
                    fontStyle: 'italic',
                  }}
                >
                  {isDone ? t('No mechanics assigned') : t('Click to assign mechanics')}
                </Typography>
              </Box>
            )}
            </Box>
          </Paper>
        </Grid>
      </Grid>

      {/* Content Grid */}
      <Grid container spacing={3}>
        {/* Parts Card */}
        <Grid item xs={12} md={6}>
          <Paper elevation={0} sx={{ height: '100%' }}>
            <CardHeader
              title={t('Parts')}
              icon={<InventoryIcon sx={{ fontSize: 20 }} />}
              action={
                <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center', flexWrap: 'wrap', justifyContent: 'flex-end' }}>
                  {/*
                    The order-status control gets its own row on phones. Alongside the
                    reorder, quick-add and Add buttons it left the header wrapping into
                    a cramped, hard-to-hit jumble on a narrow screen.
                  */}
                  {currentOrganization?.parts_order_tracking_enabled && (!isDone || maintenance?.parts_order_status) && (
                    <Box
                      sx={{
                        flexBasis: { xs: '100%', sm: 'auto' },
                        display: 'flex',
                        justifyContent: 'flex-end',
                        mb: { xs: 0.5, sm: 0 },
                      }}
                    >
                    {(
                    isDone ? (
                      maintenance.parts_order_status && (
                        <Tooltip title={t(`parts_order.${maintenance.parts_order_status}`)}>
                          <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: PARTS_ORDER_CONFIG[maintenance.parts_order_status]?.color, flexShrink: 0 }} />
                        </Tooltip>
                      )
                    ) : (
                      <Select
                        size="small"
                        data-testid="parts-order-status-select"
                        value={maintenance.parts_order_status || ''}
                        onChange={(e) => handlePartsOrderStatusChange(e.target.value)}
                        displayEmpty
                        sx={{ minWidth: 130, height: 30, fontSize: '12px', '& .MuiSelect-select': { py: 0.5, display: 'flex', alignItems: 'center', gap: 0.75 } }}
                        renderValue={(val) => (
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                            {val && <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: PARTS_ORDER_CONFIG[val]?.color, flexShrink: 0 }} />}
                            <Typography sx={{ fontSize: '12px' }}>{val ? t(`parts_order.${val}`) : t('parts_order.status')}</Typography>
                          </Box>
                        )}
                      >
                        {['not_ordered', 'ordered', 'arrived', 'not_needed'].map((s) => (
                          <MenuItem key={s} value={s} sx={{ fontSize: '13px' }}>
                            <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: PARTS_ORDER_CONFIG[s]?.color, mr: 1, flexShrink: 0 }} />
                            {t(`parts_order.${s}`)}
                          </MenuItem>
                        ))}
                      </Select>
                    )
                    )}
                    </Box>
                  )}
                  {!isDone && canAddParts && (maintenance?.parts?.length || 0) > 1 && (
                    <Tooltip title={t('Reorder lines')}>
                      <IconButton
                        size="small"
                        data-testid="reorder-mode-toggle-parts"
                        onClick={() => setReorderMode((v) => !v)}
                        sx={{
                          color: reorderMode ? 'primary.main' : 'text.disabled',
                          border: 1,
                          borderColor: reorderMode ? 'primary.main' : 'divider',
                          borderRadius: '8px',
                        }}
                      >
                        <SwapVertIcon sx={{ fontSize: 18 }} />
                      </IconButton>
                    </Tooltip>
                  )}
                  {!isDone && currentOrganization?.pientarvikelisa_mode && currentOrganization.pientarvikelisa_mode !== 'disabled'
                    && !maintenance?.parts?.some(p => p.is_pientarvikelisa) && (
                    <Tooltip title={t('Add pientarvikelisä')}>
                      <IconButton
                        size="small"
                        data-testid="add-pientarvikelisa-button"
                        onClick={handleTogglePientarvikelisa}
                        disabled={pientarvikelisaBusy}
                        sx={{
                          color: 'secondary.main',
                          border: 1,
                          borderColor: 'divider',
                          borderRadius: '8px',
                          fontSize: '12px',
                          fontWeight: 500,
                          fontFamily: "'Plus Jakarta Sans', sans-serif",
                          px: 1.5,
                          '&:hover': {
                            borderColor: 'secondary.main',
                            bgcolor: 'transparent',
                          },
                        }}
                      >
                        <Typography sx={{ fontSize: '12px', fontWeight: 500, color: 'secondary.main' }}>
                          {t('Small supplies surcharge btn')}
                        </Typography>
                      </IconButton>
                    </Tooltip>
                  )}
                  {!isDone && canAddParts && (
                    <>
                      <Tooltip title={t('Quick add')}>
                        <IconButton
                          size="small"
                          data-testid="quick-add-part-button"
                          onClick={() => setQuickAddPartOpen(true)}
                          sx={{
                            color: 'secondary.main',
                            border: 1,
                            borderColor: 'divider',
                            borderRadius: '8px',
                            '&:hover': {
                              borderColor: 'secondary.main',
                              bgcolor: 'transparent',
                            },
                          }}
                        >
                          <FlashOnIcon sx={{ fontSize: 18 }} />
                        </IconButton>
                      </Tooltip>
                      <Button
                        variant="outlined"
                        startIcon={<AddIcon />}
                        size="small"
                        data-testid="add-part-button"
                        onClick={() => setPartModalOpen(true)}
                        sx={{
                          borderColor: 'divider',
                          color: 'secondary.main',
                          borderRadius: '8px',
                          fontWeight: 500,
                          fontFamily: "'Plus Jakarta Sans', sans-serif",
                          '&:hover': {
                            borderColor: 'secondary.main',
                            bgcolor: 'transparent',
                          },
                        }}
                      >
                        {t('Add')}
                      </Button>
                    </>
                  )}
                </Box>
              }
            />
            <Box sx={{ p: 2.5 }}>
              {maintenance?.parts && maintenance.parts.length > 0 ? (
                maintenance.parts.map((part, idx) => (
                  <Box
                    key={part.id}
                    onClick={() => handlePartClick(part)}
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      py: 1.5,
                      px: 1,
                      mx: -1,
                      borderRadius: '8px',
                      borderBottom: idx < maintenance.parts.length - 1 ? 1 : 0,
                      borderColor: 'divider',
                      cursor: isDone ? 'default' : 'pointer',
                      transition: 'background-color 0.15s',
                      '&:hover': {
                        bgcolor: isDone ? 'transparent' : 'action.hover',
                      },
                    }}
                  >
                    {reorderMode && !isDone && maintenance.parts.length > 1 && (
                      <Box sx={{ display: 'flex', flexDirection: 'column', mr: 1, flexShrink: 0 }}>
                        <IconButton
                          size="small"
                          disabled={idx === 0 || reordering}
                          data-testid={`line-move-up-${part.id}`}
                          onClick={(e) => { e.stopPropagation(); handleMoveLine('parts', idx, -1); }}
                          sx={{ p: 0.25 }}
                        >
                          <KeyboardArrowUpIcon sx={{ fontSize: 18 }} />
                        </IconButton>
                        <IconButton
                          size="small"
                          disabled={idx === maintenance.parts.length - 1 || reordering}
                          data-testid={`line-move-down-${part.id}`}
                          onClick={(e) => { e.stopPropagation(); handleMoveLine('parts', idx, 1); }}
                          sx={{ p: 0.25 }}
                        >
                          <KeyboardArrowDownIcon sx={{ fontSize: 18 }} />
                        </IconButton>
                      </Box>
                    )}
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                        <Typography sx={{ fontSize: '14px', color: 'text.primary', fontWeight: 500 }}>
                          {part.name}
                        </Typography>
                        {part.is_pientarvikelisa && (
                          <Chip
                            label={t('Small supplies surcharge')}
                            size="small"
                            sx={{ fontSize: '10px', height: '18px', bgcolor: 'grey.200', color: 'text.secondary' }}
                          />
                        )}
                        {part.is_estimate && (
                          <>
                            <Chip
                              label={t('quoteMachine.swap.estimateChip')}
                              size="small"
                              data-testid={`estimate-chip-${part.id}`}
                              sx={{ fontSize: '10px', height: '18px', bgcolor: 'warning.light', color: 'warning.contrastText' }}
                            />
                            {!isDone && canAddParts && (
                              <Button
                                size="small"
                                variant="outlined"
                                color="warning"
                                data-testid={`swap-estimate-${part.id}`}
                                onClick={(e) => { e.stopPropagation(); setSwapEstimateLine(part); }}
                                sx={{ textTransform: 'none', borderRadius: '6px', py: 0, px: 1, minHeight: 0, fontSize: '11px', lineHeight: 1.6 }}
                              >
                                {t('quoteMachine.swap.button')}
                              </Button>
                            )}
                          </>
                        )}
                        {part.awaiting_confirmation && (
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 0.5,
                              bgcolor: 'warning.light',
                              color: 'warning.contrastText',
                              px: 0.75,
                              py: 0.25,
                              borderRadius: '4px',
                              fontSize: '11px',
                              fontWeight: 600,
                            }}
                          >
                            <HourglassEmptyIcon sx={{ fontSize: 12 }} />
                            {t('Awaiting approval')}
                          </Box>
                        )}
                        {part.confirmation_status === 'denied' && (
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 0.5,
                              bgcolor: 'error.light',
                              color: 'error.contrastText',
                              px: 0.75,
                              py: 0.25,
                              borderRadius: '4px',
                              fontSize: '11px',
                              fontWeight: 600,
                            }}
                          >
                            <CancelIcon sx={{ fontSize: 12 }} />
                            {t('Customer declined')}
                          </Box>
                        )}
                        {maintenance?.billing_customer && part.invoice_target === 'customer' && (
                          <Chip label={t('Customer')} size="small"
                            sx={{ fontSize: '10px', height: '18px', bgcolor: 'warning.light', color: 'warning.contrastText' }} />
                        )}
                        {part.supplier_integration_id && (
                          <Box sx={{
                            display: 'flex', alignItems: 'center', gap: 0.5,
                            bgcolor: 'info.light', color: 'info.contrastText',
                            px: 0.75, py: 0.25, borderRadius: '4px',
                            fontSize: '11px', fontWeight: 600,
                          }}>
                            <LocalShippingIcon sx={{ fontSize: 12 }} />
                            {part.supplier_display_name}
                          </Box>
                        )}
                        {part.is_supplier_ordered && (
                          <Box sx={{
                            display: 'flex', alignItems: 'center', gap: 0.5,
                            bgcolor: 'success.light', color: 'success.contrastText',
                            px: 0.75, py: 0.25, borderRadius: '4px',
                            fontSize: '11px', fontWeight: 600,
                          }}>
                            <CheckIcon sx={{ fontSize: 12 }} />
                            {t('supplierOrder.ordered')}
                          </Box>
                        )}
                        {part.reduce_from_inventory === false && currentOrganization?.inventory_tracking_enabled && (
                          <Tooltip title={t('inventory.orderedForJobHelp')}>
                            <Box
                              data-testid={`part-ordered-for-job-${part.id}`}
                              sx={{
                                display: 'flex', alignItems: 'center', gap: 0.5,
                                bgcolor: 'grey.200', color: 'text.secondary',
                                px: 0.75, py: 0.25, borderRadius: '4px',
                                fontSize: '11px', fontWeight: 600,
                              }}
                            >
                              <Inventory2Icon sx={{ fontSize: 12 }} />
                              {t('inventory.orderedForJobChip')}
                            </Box>
                          </Tooltip>
                        )}
                      </Box>
                      {part.description && (
                        <Typography sx={{ fontSize: '12px', color: 'text.secondary', whiteSpace: 'pre-line' }}>
                          {part.description}
                        </Typography>
                      )}
                      {(part.primary_code || part.manufacturer_code) && (
                        <Typography sx={{ fontSize: '12px', color: 'text.secondary' }}>
                          {part.primary_code || part.manufacturer_code}
                        </Typography>
                      )}
                      {part.maintenance_job_name && (
                        <Typography sx={{ fontSize: '11px', color: 'text.disabled', fontStyle: 'italic' }}>
                          → {part.maintenance_job_name}
                        </Typography>
                      )}
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, ml: 2 }}>
                      <Typography sx={{ fontSize: '13px', color: 'text.secondary', minWidth: '50px', textAlign: 'right' }}>
                        {parseFloat(part.quantity) !== 1 ? `${formatQuantity(part.quantity)} × ${formatPrice(part.effective_price_incl_vat || part.effective_price)} €` : ''}
                      </Typography>
                      <Box sx={{ minWidth: '70px', textAlign: 'right' }}>
                        {parseFloat(part.discount_percent || 0) > 0 ? (
                          <>
                            <span style={{ textDecoration: 'line-through', color: '#94a3b8', fontSize: '0.8rem' }}>
                              {formatPrice(part.original_line_total_incl_vat)} €
                            </span>
                            <span style={{ color: '#16a34a', fontSize: '0.75rem', marginLeft: 4 }}>−{part.discount_percent}%</span>
                            <br />
                            <Typography component="span" sx={{ fontSize: '14px', fontWeight: 600, color: 'text.primary' }}>
                              {formatPrice(part.line_total_incl_vat)} €
                            </Typography>
                          </>
                        ) : (
                          <Typography sx={{ fontSize: '14px', fontWeight: 600, color: parseFloat(part.line_total_incl_vat) < 0 ? 'error.main' : 'text.primary' }}>
                            {part.line_total_incl_vat ? `${formatPrice(part.line_total_incl_vat)} €` : (part.line_total ? `${formatPrice(part.line_total)} €` : '-')}
                          </Typography>
                        )}
                      </Box>
                    </Box>
                  </Box>
                ))
              ) : (
                <Box sx={{ py: 5, textAlign: 'center', color: 'text.disabled' }}>
                  <InventoryIcon sx={{ fontSize: 40, mb: 1.5, opacity: 0.4 }} />
                  <Typography sx={{ fontSize: '14px' }}>{t('No parts added')}</Typography>
                  {currentOrganization?.oem_service_enabled && maintenance?.vehicle?.tecdoc_id &&
                   (maintenance?.jobs?.length || 0) === 0 && (
                    <Button
                      variant="outlined"
                      startIcon={<AutoAwesomeOutlinedIcon />}
                      onClick={() => setOemDialogOpen(true)}
                      sx={{ mt: 2, borderRadius: '10px', textTransform: 'none', borderColor: 'secondary.main', color: 'secondary.main' }}
                    >
                      {t('oem.addOemService', { defaultValue: 'Lisää OEM-huolto' })}
                    </Button>
                  )}
                </Box>
              )}
              {!isDone && supplierOrderGroups.length > 0 && (
                <Box sx={{ mt: 1.5 }}>
                  {supplierOrderGroups.map(group => (
                    <Box key={group.integrationId} sx={{
                      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                      flexWrap: 'wrap', gap: 1, p: 1.5,
                      bgcolor: '#f0f7ff', borderRadius: '8px', mb: 1,
                      border: 1, borderColor: '#c2dbf4',
                    }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <LocalShippingIcon sx={{ fontSize: 18, color: 'info.main' }} />
                        <Typography sx={{ fontSize: '13px', fontWeight: 500 }}>
                          {t('supplierOrder.partsOrderable', { count: group.parts.length, supplier: group.integrationName })}
                        </Typography>
                      </Box>
                      <Button size="small" variant="contained"
                        onClick={(e) => {
                          e.stopPropagation();
                          setSupplierOrderIntegration(group);
                          setSupplierOrderDialogOpen(true);
                        }}
                        sx={{ borderRadius: '8px', textTransform: 'none', fontWeight: 600 }}
                      >
                        {t('supplierOrder.orderButton', { supplier: group.integrationName })}
                      </Button>
                    </Box>
                  ))}
                </Box>
              )}
            </Box>
          </Paper>
        </Grid>

        {/* Jobs Card */}
        <Grid item xs={12} md={6}>
          <Paper elevation={0} sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <CardHeader
              title={t('Jobs')}
              icon={<BuildIcon sx={{ fontSize: 20 }} />}
              action={!isDone && canAddJobs && (
                <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
                  {!isDone && (maintenance?.jobs?.length || 0) > 1 && (
                    <Tooltip title={t('Reorder lines')}>
                      <IconButton
                        size="small"
                        data-testid="reorder-mode-toggle-jobs"
                        onClick={() => setReorderMode((v) => !v)}
                        sx={{
                          color: reorderMode ? 'primary.main' : 'text.disabled',
                          border: 1,
                          borderColor: reorderMode ? 'primary.main' : 'divider',
                          borderRadius: '8px',
                        }}
                      >
                        <SwapVertIcon sx={{ fontSize: 18 }} />
                      </IconButton>
                    </Tooltip>
                  )}
                  <Tooltip title={t('Quick add')}>
                    <IconButton
                      size="small"
                      data-testid="quick-add-job-button"
                      onClick={() => setQuickAddJobOpen(true)}
                      sx={{
                        color: 'secondary.main',
                        border: 1,
                        borderColor: 'divider',
                        borderRadius: '8px',
                        '&:hover': {
                          borderColor: 'secondary.main',
                          bgcolor: 'transparent',
                        },
                      }}
                    >
                      <FlashOnIcon sx={{ fontSize: 18 }} />
                    </IconButton>
                  </Tooltip>
                  {maintenance?.vehicle?.manufacturer && maintenance?.vehicle?.model && (
                    <Tooltip title={t('AI estimate')}>
                      <IconButton
                        size="small"
                        data-testid="ai-estimate-job-button"
                        onClick={() => setAiEstimateOpen(true)}
                        sx={{
                          color: 'info.main',
                          border: 1,
                          borderColor: 'divider',
                          borderRadius: '8px',
                          '&:hover': {
                            borderColor: 'info.main',
                            bgcolor: 'transparent',
                          },
                        }}
                      >
                        <AutoFixHighIcon sx={{ fontSize: 18 }} />
                      </IconButton>
                    </Tooltip>
                  )}
                  <Button
                    variant="outlined"
                    startIcon={<AddIcon />}
                    size="small"
                    data-testid="add-job-button"
                    onClick={() => setTaskModalOpen(true)}
                    sx={{
                      borderColor: 'divider',
                      color: 'secondary.main',
                      borderRadius: '8px',
                      fontWeight: 500,
                      fontFamily: "'Plus Jakarta Sans', sans-serif",
                      '&:hover': {
                        borderColor: 'secondary.main',
                        bgcolor: 'transparent',
                      },
                    }}
                  >
                    {t('Add')}
                  </Button>
                </Box>
              )}
            />
            <Box sx={{ p: 2.5, flex: 1 }}>
              {maintenance?.jobs && maintenance.jobs.length > 0 ? (
                maintenance.jobs.map((job, idx) => (
                  <Box
                    key={job.id}
                    onClick={() => handleJobClick(job)}
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      py: 1.5,
                      px: 1,
                      mx: -1,
                      borderRadius: '8px',
                      borderBottom: idx < maintenance.jobs.length - 1 ? 1 : 0,
                      borderColor: 'divider',
                      cursor: isDone ? 'default' : 'pointer',
                      transition: 'background-color 0.15s',
                      bgcolor: job.is_completed ? 'rgba(16, 185, 129, 0.05)' : 'transparent',
                      '&:hover': {
                        bgcolor: isDone ? (job.is_completed ? 'rgba(16, 185, 129, 0.05)' : 'transparent') : 'action.hover',
                      },
                    }}
                  >
                    {reorderMode && !isDone && maintenance.jobs.length > 1 && (
                      <Box sx={{ display: 'flex', flexDirection: 'column', mr: 1, flexShrink: 0 }}>
                        <IconButton
                          size="small"
                          disabled={idx === 0 || reordering}
                          data-testid={`line-move-up-${job.id}`}
                          onClick={(e) => { e.stopPropagation(); handleMoveLine('jobs', idx, -1); }}
                          sx={{ p: 0.25 }}
                        >
                          <KeyboardArrowUpIcon sx={{ fontSize: 18 }} />
                        </IconButton>
                        <IconButton
                          size="small"
                          disabled={idx === maintenance.jobs.length - 1 || reordering}
                          data-testid={`line-move-down-${job.id}`}
                          onClick={(e) => { e.stopPropagation(); handleMoveLine('jobs', idx, 1); }}
                          sx={{ p: 0.25 }}
                        >
                          <KeyboardArrowDownIcon sx={{ fontSize: 18 }} />
                        </IconButton>
                      </Box>
                    )}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flex: 1, minWidth: 0 }}>
                      {/* Completion indicator */}
                      <Box
                        sx={{
                          width: 20,
                          height: 20,
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          bgcolor: job.is_completed ? 'success.main' : 'action.selected',
                          color: job.is_completed ? 'white' : 'text.disabled',
                          flexShrink: 0,
                        }}
                      >
                        {job.is_completed ? (
                          <CheckIcon sx={{ fontSize: 14 }} />
                        ) : (
                          <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: 'text.disabled' }} />
                        )}
                      </Box>
                      <Box sx={{ minWidth: 0 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                          <Typography
                            sx={{
                              fontSize: '14px',
                              color: job.is_completed ? 'text.secondary' : 'text.primary',
                              fontWeight: 500,
                              textDecoration: job.is_completed ? 'line-through' : 'none',
                            }}
                          >
                            {job.name}
                          </Typography>
                          {job.awaiting_confirmation && (
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 0.5,
                                bgcolor: 'warning.light',
                                color: 'warning.contrastText',
                                px: 0.75,
                                py: 0.25,
                                borderRadius: '4px',
                                fontSize: '11px',
                                fontWeight: 600,
                              }}
                            >
                              <HourglassEmptyIcon sx={{ fontSize: 12 }} />
                              {t('Awaiting approval')}
                            </Box>
                          )}
                          {job.confirmation_status === 'denied' && (
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 0.5,
                                bgcolor: 'error.light',
                                color: 'error.contrastText',
                                px: 0.75,
                                py: 0.25,
                                borderRadius: '4px',
                                fontSize: '11px',
                                fontWeight: 600,
                              }}
                            >
                              <CancelIcon sx={{ fontSize: 12 }} />
                              {t('Customer declined')}
                            </Box>
                          )}
                          {maintenance?.billing_customer && job.invoice_target === 'customer' && (
                            <Chip label={t('Customer')} size="small"
                              sx={{ fontSize: '10px', height: '18px', bgcolor: 'warning.light', color: 'warning.contrastText' }} />
                          )}
                          {job.ai_estimation && (
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 0.5,
                                bgcolor: 'info.light',
                                color: 'info.contrastText',
                                px: 0.75,
                                py: 0.25,
                                borderRadius: '4px',
                                fontSize: '11px',
                                fontWeight: 600,
                              }}
                            >
                              <AutoFixHighIcon sx={{ fontSize: 12 }} />
                              {t('AI')}
                            </Box>
                          )}
                        </Box>
                        {job.description && (
                          <Typography sx={{ fontSize: '12px', color: 'text.secondary', whiteSpace: 'pre-line' }}>
                            {job.description}
                          </Typography>
                        )}
                        {job.price_type === 'hourly' && (
                          <Typography sx={{ fontSize: '12px', color: 'text.secondary' }}>
                            {formatQuantity(job.quantity)} h × {formatPrice(job.effective_price_incl_vat || job.effective_price)} €/h
                          </Typography>
                        )}
                        {/* Fixed-price line: the job's estimate, what it adds to the labor time total. Not billed. */}
                        {lineEstimateMinutes(job) !== null && (
                          <Typography
                            data-testid={`job-line-estimate-${job.id}`}
                            sx={{ fontSize: '12px', color: 'text.secondary', display: 'flex', alignItems: 'center', gap: 0.5 }}
                          >
                            <ScheduleIcon sx={{ fontSize: 13 }} />
                            {t('laborTime.lineEstimate', { hours: formatLaborHours(lineEstimateMinutes(job)) })}
                          </Typography>
                        )}
                        {job.employees_data && job.employees_data.length > 0 && (
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.5, flexWrap: 'wrap' }}>
                            {job.employees_data.map((emp) => (
                              <Box
                                key={emp.id}
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 0.5,
                                  bgcolor: 'rgba(49, 130, 206, 0.08)',
                                  borderRadius: '10px',
                                  px: 0.75,
                                  py: 0.25,
                                }}
                              >
                                <Box
                                  sx={{
                                    width: 16,
                                    height: 16,
                                    borderRadius: '50%',
                                    bgcolor: 'primary.main',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '8px',
                                    color: '#fff',
                                    fontWeight: 600,
                                  }}
                                >
                                  {emp.name?.split(' ').map(n => n[0]).join('').substring(0, 2)}
                                </Box>
                                <Typography sx={{ fontSize: '11px', color: 'text.secondary', fontWeight: 500 }}>
                                  {emp.name}
                                </Typography>
                              </Box>
                            ))}
                          </Box>
                        )}
                      </Box>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, ml: 2 }}>
                      <Typography sx={{ fontSize: '13px', color: 'text.secondary', minWidth: '50px', textAlign: 'right' }}>
                        {parseFloat(job.quantity) !== 1 && job.price_type !== 'hourly' ? `${formatQuantity(job.quantity)} × ${formatPrice(job.effective_price_incl_vat || job.effective_price)} €` : ''}
                      </Typography>
                      <Box sx={{ minWidth: '70px', textAlign: 'right' }}>
                        {parseFloat(job.discount_percent || 0) > 0 ? (
                          <>
                            <span style={{ textDecoration: 'line-through', color: '#94a3b8', fontSize: '0.8rem' }}>
                              {formatPrice(job.original_line_total_incl_vat)} €
                            </span>
                            <span style={{ color: '#16a34a', fontSize: '0.75rem', marginLeft: 4 }}>−{job.discount_percent}%</span>
                            <br />
                            <Typography component="span" sx={{ fontSize: '14px', fontWeight: 600, color: job.is_completed ? 'text.secondary' : 'text.primary' }}>
                              {formatPrice(job.line_total_incl_vat)} €
                            </Typography>
                          </>
                        ) : (
                          <Typography sx={{ fontSize: '14px', fontWeight: 600, color: parseFloat(job.line_total_incl_vat) < 0 ? 'error.main' : (job.is_completed ? 'text.secondary' : 'text.primary') }}>
                            {job.line_total_incl_vat ? `${formatPrice(job.line_total_incl_vat)} €` : (job.line_total ? `${formatPrice(job.line_total)} €` : '-')}
                          </Typography>
                        )}
                      </Box>
                    </Box>
                  </Box>
                ))
              ) : (
                <Box sx={{ py: 5, textAlign: 'center', color: 'text.disabled' }}>
                  <BuildIcon sx={{ fontSize: 40, mb: 1.5, opacity: 0.4 }} />
                  <Typography sx={{ fontSize: '14px' }}>{t('No jobs added')}</Typography>
                </Box>
              )}
            </Box>
            {/*
              Labour time total, pinned to the bottom of the card. Hidden until at least one
              line has a known time, so workshops that never set estimates see no change.
            */}
            {laborTime.countedCount > 0 && (
              <Tooltip title={t('laborTime.tooltip')} placement="top" arrow>
                <Box
                  data-testid="jobs-labor-time"
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    columnGap: 2,
                    rowGap: 0.25,
                    px: 2.5,
                    py: 1.75,
                    borderTop: 1,
                    borderColor: 'divider',
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <ScheduleIcon sx={{ fontSize: 18, color: 'text.secondary' }} />
                    <Typography sx={{ fontSize: '13px', fontWeight: 500, color: 'text.secondary' }}>
                      {t('laborTime.total')}
                    </Typography>
                  </Box>
                  <Typography
                    data-testid="jobs-labor-time-value"
                    sx={{ fontSize: '15px', fontWeight: 600, color: 'text.primary', whiteSpace: 'nowrap' }}
                  >
                    {t('laborTime.hours', { hours: formatLaborHours(laborTime.minutes) })}
                  </Typography>
                  {laborTime.missingCount > 0 && (
                    <Typography
                      data-testid="jobs-labor-time-missing"
                      sx={{ width: '100%', pl: 3.25, fontSize: '12px', color: 'text.secondary' }}
                    >
                      {t('laborTime.missingEstimate', { count: laborTime.missingCount })}
                    </Typography>
                  )}
                </Box>
              </Tooltip>
            )}
          </Paper>
        </Grid>
      </Grid>

      {/* Notes Section */}
      <NotesSection maintenance={maintenance} setMaintenance={setMaintenance} />

      {/* Ostolaskut (purchase ledger): linked supplier invoices and receipts; renders nothing
          without the feature and the purchase_invoices.view key. */}
      <PurchaseInvoicesSection maintenance={maintenance} />

      {/* Work time (live clock) panel — only when the opt-in timer system is on (same gate as the
          top-bar pill, polling and board). Off → the /timeclock endpoints 404 and there's no panel. */}
      {(currentOrganization?.time_clock_enabled ?? false) && maintenance && (
        <Box sx={{ mt: 3 }}>
          <WorkOrderClockPanel maintenance={maintenance} onMaintenanceChanged={refetchMaintenanceState} />
        </Box>
      )}

      {/* Scheduling Section */}
      <SchedulingSection maintenance={maintenance} setMaintenance={setMaintenance} />

      {/* Offer sent info - only visible in quote state */}
      {maintenance?.state === 'quote' && (
        <QuoteSentBanner
          maintenance={maintenance}
          onError={(message) => setOfferSentSnackbar(message)}
          onShowVersions={() => setQuoteHistoryOpen(true)}
        />
      )}

      {/* Price Summary */}
      <Paper elevation={0} sx={{ p: 3, mt: maintenance?.state === 'quote' && (maintenance?.latest_quote || maintenance?.last_offer_sent) ? 1.5 : 3 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 2 }}>
          <Box sx={{ flex: 1 }}>
            {/* VAT Breakdown */}
            <Box sx={{ mb: 2 }}>
              {/*
                Parts vs labour split. Only shown when both sides have lines —
                on a parts-only or labour-only work order it would just repeat
                the subtotal. These are pre-discount: an order discount is not
                attributable to a group, hence the caption below.
              */}
              {maintenance?.parts?.length > 0 && maintenance?.jobs?.length > 0 && (
                <Box sx={{ mb: 1 }} data-testid="maintenance-group-subtotals">
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
                    <Typography sx={{ fontSize: '13px', color: 'text.secondary' }}>
                      {t('Parts total (incl. VAT)')}
                    </Typography>
                    <Typography sx={{ fontSize: '14px', color: 'text.secondary' }} data-testid="parts-subtotal">
                      {formatPrice(totals.partsTotalInclVat)} €
                    </Typography>
                  </Box>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
                    <Typography sx={{ fontSize: '13px', color: 'text.secondary' }}>
                      {t('Labor total (incl. VAT)')}
                    </Typography>
                    <Typography sx={{ fontSize: '14px', color: 'text.secondary' }} data-testid="jobs-subtotal">
                      {formatPrice(totals.jobsTotalInclVat)} €
                    </Typography>
                  </Box>
                  {parseFloat(maintenance?.order_discount_total || 0) > 0 && (
                    <Typography sx={{ fontSize: '11px', color: 'text.disabled', mb: 0.5 }}>
                      {t('before discount')}
                    </Typography>
                  )}
                  <Divider sx={{ my: 1 }} />
                </Box>
              )}

              {/* Subtotal excl. VAT */}
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
                <Typography sx={{ fontSize: '13px', color: 'text.secondary' }}>
                  {t('Subtotal (excl. VAT)')}
                </Typography>
                <Typography sx={{ fontSize: '14px', color: 'text.secondary' }}>
                  {formatPrice(totals.totalExclVat)} €
                </Typography>
              </Box>

              {/* VAT by rate */}
              {Object.keys(totals.vatByRate).sort((a, b) => parseFloat(b) - parseFloat(a)).map(rate => (
                <Box key={rate} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
                  <Typography sx={{ fontSize: '13px', color: 'text.secondary' }}>
                    {t('VAT')} {formatPrice(rate, 1)} %
                  </Typography>
                  <Typography sx={{ fontSize: '14px', color: 'text.secondary' }}>
                    {formatPrice(totals.vatByRate[rate].amount)} €
                  </Typography>
                </Box>
              ))}

              {/* Order discount row — or add-discount link */}
              {parseFloat(maintenance?.order_discount_total || 0) > 0 ? (
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <Typography sx={{ fontSize: '13px', color: '#16a34a' }}>
                      {t('orderDiscount')}
                      {parseFloat(maintenance?.discount_percent || 0) > 0 && (
                        <span style={{ marginLeft: 4 }}>({maintenance.discount_percent}%)</span>
                      )}
                    </Typography>
                    {canEditOrderDiscount && (
                      <IconButton size="small" onClick={() => setOrderDiscountDialogOpen(true)} sx={{ p: 0.25 }}>
                        <EditIcon sx={{ fontSize: 16, color: '#16a34a' }} />
                      </IconButton>
                    )}
                  </Box>
                  <Typography sx={{ fontSize: '14px', color: '#16a34a' }}>
                    −{formatPrice(maintenance.order_discount_total)} €
                  </Typography>
                </Box>
              ) : (
                canEditOrderDiscount && (maintenance?.parts?.length > 0 || maintenance?.jobs?.length > 0) && (
                  <Box sx={{ mb: 0.5 }}>
                    <Typography
                      data-testid="add-order-discount"
                      sx={{
                        fontSize: '13px',
                        color: 'primary.main',
                        cursor: 'pointer',
                        '&:hover': { textDecoration: 'underline' },
                      }}
                      onClick={() => setOrderDiscountDialogOpen(true)}
                    >
                      + {t('addDiscount')}
                    </Typography>
                  </Box>
                )
              )}

              {/* Divider */}
              <Divider sx={{ my: 1.5 }} />
            </Box>

            {/* Margin Info - costs.view_margins */}
            {canViewMargins && (maintenance?.parts?.length > 0 || maintenance?.jobs?.length > 0) && (
              <Box sx={{ mb: 1.5 }}>
                <Box
                  onClick={() => setMarginInfoOpen(!marginInfoOpen)}
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    cursor: 'pointer',
                    py: 0.5,
                    px: 0.5,
                    '&:hover': { bgcolor: 'action.hover' },
                    borderRadius: '4px',
                  }}
                >
                  <Typography sx={{ fontSize: '13px', color: 'text.secondary', fontWeight: 500 }}>
                    {t('Margin info')}
                  </Typography>
                  {marginInfoOpen ? (
                    <KeyboardArrowUpIcon sx={{ fontSize: 18, color: 'text.secondary' }} />
                  ) : (
                    <KeyboardArrowDownIcon sx={{ fontSize: 18, color: 'text.secondary' }} />
                  )}
                </Box>

                <Collapse in={marginInfoOpen}>
                  <Box sx={{
                    mt: 1,
                    p: 2,
                    bgcolor: totals.totalMargin < 0 ? 'rgba(239, 68, 68, 0.06)' : 'rgba(16, 185, 129, 0.06)',
                    borderRadius: '8px',
                    border: '1px solid',
                    borderColor: totals.totalMargin < 0 ? 'rgba(239, 68, 68, 0.15)' : 'rgba(16, 185, 129, 0.15)',
                  }}>
                    {/* Parts margin section: sales -> cost -> margin, per customer request */}
                    {maintenance?.parts?.length > 0 && (
                      <>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                          <Typography sx={{ fontSize: '13px', color: 'text.secondary' }}>
                            {t('Parts sales')}
                          </Typography>
                          <Typography sx={{ fontSize: '13px' }}>
                            {formatPrice(totals.partsNetRevenue)} €
                          </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                          <Typography sx={{ fontSize: '13px', color: 'text.secondary' }}>
                            {t('Parts cost total')}
                          </Typography>
                          <Typography sx={{ fontSize: '13px' }}>
                            {formatPrice(totals.partsCostTotal)} €
                          </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                          <Typography sx={{ fontSize: '13px', color: 'text.secondary' }}>
                            {t('Parts margin')}
                          </Typography>
                          <Typography sx={{
                            fontSize: '13px',
                            color: totals.partsMargin < 0 ? 'error.main' : 'success.main',
                          }}>
                            {formatPrice(totals.partsMargin)} €
                            {totals.partsMarginPercent !== null && (
                              <span style={{ marginLeft: 4, fontWeight: 400 }}>
                                ({formatPrice(totals.partsMarginPercent, 1)} %)
                              </span>
                            )}
                          </Typography>
                        </Box>
                      </>
                    )}
                    {/* Jobs margin section: sales -> cost -> margin */}
                    {maintenance?.jobs?.length > 0 && (
                      <>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                          <Typography sx={{ fontSize: '13px', color: 'text.secondary' }}>
                            {t('Labor sales')}
                          </Typography>
                          <Typography sx={{ fontSize: '13px' }}>
                            {formatPrice(totals.jobsNetRevenue)} €
                          </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                          <Typography sx={{ fontSize: '13px', color: 'text.secondary' }}>
                            {t('Labor cost total')}
                          </Typography>
                          <Typography sx={{ fontSize: '13px' }}>
                            {formatPrice(totals.jobsCostTotal)} €
                          </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                          <Typography sx={{ fontSize: '13px', color: 'text.secondary' }}>
                            {t('Labor margin')}
                          </Typography>
                          <Typography sx={{
                            fontSize: '13px',
                            color: totals.jobsMargin < 0 ? 'error.main' : 'success.main',
                          }}>
                            {formatPrice(totals.jobsMargin)} €
                            {totals.jobsMarginPercent !== null && (
                              <span style={{ marginLeft: 4, fontWeight: 400 }}>
                                ({formatPrice(totals.jobsMarginPercent, 1)} %)
                              </span>
                            )}
                          </Typography>
                        </Box>
                      </>
                    )}
                    {/* Total margin */}
                    <Divider sx={{ my: 1 }} />
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <Typography sx={{ fontSize: '13px', fontWeight: 600, color: 'text.secondary' }}>
                        {t('Total margin')}
                      </Typography>
                      <Typography sx={{
                        fontSize: '14px',
                        fontWeight: 600,
                        color: totals.totalMargin < 0 ? 'error.main' : 'success.main',
                      }}>
                        {formatPrice(totals.totalMargin)} €
                        {totals.totalMarginPercent !== null && (
                          <span style={{ marginLeft: 4, fontWeight: 400 }}>
                            ({formatPrice(totals.totalMarginPercent, 1)} %)
                          </span>
                        )}
                      </Typography>
                    </Box>
                    {/* Warnings */}
                    {totals.partsWithoutCostCount > 0 && (
                      <Typography sx={{ fontSize: '11px', color: 'warning.dark', mt: 1 }}>
                        {totals.partsWithoutCostCount} {t('parts without cost price in margin')}
                      </Typography>
                    )}
                    {totals.jobsWithoutCostCount > 0 && (
                      <Typography sx={{ fontSize: '11px', color: 'warning.dark', mt: 0.5 }}>
                        {totals.jobsWithoutCostCount} {t('jobs without cost price in margin')}
                      </Typography>
                    )}
                  </Box>
                </Collapse>
              </Box>
            )}

            {/* Total (incl. VAT) */}
            <Typography sx={{ fontSize: '14px', color: 'text.secondary', mb: 0.5 }}>
              {t('Total (incl. VAT)')}
            </Typography>
            <Typography
              data-testid="maintenance-grand-total"
              sx={{
                fontSize: '32px',
                fontWeight: 700,
                color: 'text.primary',
                fontFamily: "'Plus Jakarta Sans', sans-serif",
              }}
            >
              {formatPrice(maintenance?.total_with_vat != null ? maintenance.total_with_vat : totals.totalInclVat)} €
            </Typography>

            {/* Invoice Info Section - Show when invoices exist */}
            {maintenance?.invoices?.length > 0 && maintenance.invoices.map((inv) => (
              <Box
                key={inv.id}
                sx={{
                  mt: 2,
                  p: 2,
                  bgcolor: inv.status === 'combined'
                    ? 'rgba(156, 163, 175, 0.08)'
                    : inv.status === 'paid'
                      ? 'rgba(16, 185, 129, 0.08)'
                      : inv.is_overdue
                        ? 'rgba(239, 68, 68, 0.08)'
                        : 'rgba(49, 130, 206, 0.08)',
                  borderRadius: '10px',
                  border: '1px solid',
                  borderColor: inv.status === 'combined'
                    ? 'rgba(156, 163, 175, 0.2)'
                    : inv.status === 'paid'
                      ? 'rgba(16, 185, 129, 0.2)'
                      : inv.is_overdue
                        ? 'rgba(239, 68, 68, 0.2)'
                        : 'rgba(49, 130, 206, 0.2)',
                  cursor: 'pointer',
                }}
                onClick={() => navigate(`/invoices/${inv.status === 'combined' && inv.combined_into ? inv.combined_into : inv.id}`)}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
                  <ReceiptIcon sx={{
                    fontSize: 18,
                    color: inv.status === 'combined'
                      ? 'text.secondary'
                      : inv.status === 'paid'
                        ? 'success.main'
                        : inv.is_overdue
                          ? 'error.main'
                          : 'secondary.main'
                  }} />
                  <Typography sx={{ fontSize: '14px', fontWeight: 600, color: 'text.primary' }}>
                    {inv.status === 'combined'
                      ? `${t('Combined invoice')}: ${inv.combined_into_invoice_number || ''}`
                      : inv.invoice_split_type === 'insurance'
                        ? t('Insurance invoice')
                        : inv.invoice_split_type === 'deductible'
                          ? t('Deductible invoice')
                          : inv.invoice_split_type === 'billing_customer'
                            ? t('Billing customer invoice')
                            : inv.invoice_split_type === 'customer_share'
                              ? t('Customer invoice')
                              : t('Invoice')}: {inv.status !== 'combined' ? inv.invoice_number : ''}
                  </Typography>
                  {inv.status !== 'combined' && inv.invoice_split_type !== 'normal' && (
                    <Typography sx={{ fontSize: '12px', color: 'text.secondary', ml: 'auto' }}>
                      {inv.customer_name}
                    </Typography>
                  )}
                </Box>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                  <Box>
                    <Typography sx={{ fontSize: '12px', color: 'text.secondary' }}>
                      {t('Status')}
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                      {inv.is_overdue && (
                        <WarningAmberIcon sx={{ fontSize: 14, color: 'error.main' }} />
                      )}
                      <Typography sx={{
                        fontSize: '13px',
                        fontWeight: 500,
                        color: inv.status === 'combined'
                          ? 'text.secondary'
                          : inv.status === 'paid'
                            ? 'success.main'
                            : inv.is_overdue
                              ? 'error.main'
                              : 'text.primary'
                      }}>
                        {inv.status === 'combined' ? t('Combined') : inv.is_overdue ? t('Overdue') : t(inv.status.charAt(0).toUpperCase() + inv.status.slice(1))}
                      </Typography>
                    </Box>
                  </Box>
                  {inv.status !== 'combined' && (
                  <Box>
                    <Typography sx={{ fontSize: '12px', color: 'text.secondary' }}>
                      {t('Due date')}
                    </Typography>
                    <Typography sx={{
                      fontSize: '13px',
                      fontWeight: 500,
                      color: inv.is_overdue ? 'error.main' : 'text.primary'
                    }}>
                      {inv.due_date ? formatDate(inv.due_date)?.split(' ')[0] : '-'}
                    </Typography>
                  </Box>
                  )}
                  {inv.status !== 'combined' && (
                  <Box>
                    <Typography sx={{ fontSize: '12px', color: 'text.secondary' }}>
                      {t('Total')}
                    </Typography>
                    <Typography sx={{ fontSize: '13px', fontWeight: 500, color: 'text.primary' }}>
                      {inv.total_incl_vat ? `${formatPrice(inv.total_incl_vat)} €` : '-'}
                    </Typography>
                  </Box>
                  )}
                </Box>
              </Box>
            ))}
          </Box>

          {/* Action Buttons */}
          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
            {maintenance?.state === 'quote' && canRequestApproval && (
              <Button
                variant="contained"
                startIcon={<DescriptionIcon />}
                onClick={() => setOfferDialogOpen(true)}
                sx={{
                  bgcolor: 'primary.main',
                  color: 'white',
                  px: 3,
                  py: 1.5,
                  borderRadius: '10px',
                  fontWeight: 500,
                  fontFamily: "'Plus Jakarta Sans', sans-serif",
                  '&:hover': {
                    bgcolor: 'primary.light',
                  },
                }}
              >
                {maintenance?.latest_quote || maintenance?.last_offer_sent ? t('Resend quote') : t('Create quote')}
              </Button>
            )}
            {['completed', 'picked_up'].includes(maintenance?.state) && canManageInvoices && (
              <>
                {maintenance?.invoices?.length > 0 && (
                  <Button
                    variant="contained"
                    startIcon={<ReceiptIcon />}
                    onClick={() => {
                      const inv = maintenance.invoices[0];
                      navigate(`/invoices/${inv.status === 'combined' && inv.combined_into ? inv.combined_into : inv.id}`);
                    }}
                    sx={{
                      bgcolor: maintenance.invoices.every(inv => inv.status === 'combined')
                        ? 'grey.600'
                        : maintenance.invoices.every(inv => inv.status === 'paid')
                          ? 'success.main'
                          : maintenance.invoices.some(inv => inv.is_overdue)
                            ? 'error.main'
                            : 'primary.main',
                      color: 'white',
                      px: 3,
                      py: 1.5,
                      borderRadius: '10px',
                      fontWeight: 500,
                      fontFamily: "'Plus Jakarta Sans', sans-serif",
                      '&:hover': {
                        bgcolor: maintenance.invoices.every(inv => inv.status === 'combined')
                          ? 'grey.700'
                          : maintenance.invoices.every(inv => inv.status === 'paid')
                            ? 'success.dark'
                            : maintenance.invoices.some(inv => inv.is_overdue)
                              ? 'error.dark'
                              : 'primary.light',
                      },
                    }}
                  >
                    {maintenance.invoices.every(inv => inv.status === 'combined')
                      ? t('Show combined invoice')
                      : maintenance.invoices.length > 1 ? t('Show invoices') : t('Show invoice')}
                  </Button>
                )}
                {canCreateInvoice && (
                  <Button
                    variant="contained"
                    startIcon={<DescriptionIcon />}
                    onClick={() => setInvoiceDialogOpen(true)}
                    sx={{
                      bgcolor: 'primary.main',
                      color: 'white',
                      px: 3,
                      py: 1.5,
                      borderRadius: '10px',
                      fontWeight: 500,
                      fontFamily: "'Plus Jakarta Sans', sans-serif",
                      '&:hover': {
                        bgcolor: 'primary.light',
                      },
                    }}
                  >
                    {t(getCreateInvoiceLabelKey(getInvoiceSplitMode(maintenance)))}
                  </Button>
                )}
                {canQuickPay && (
                  <>
                    <Button
                      variant="outlined"
                      color="success"
                      startIcon={<CreditCardIcon />}
                      onClick={() => setQuickPayMethod('card')}
                      aria-label={t('Card payment')}
                      data-testid="quick-pay-card"
                      sx={{ minWidth: { xs: 0, sm: 64 }, px: { xs: 1.5, sm: 3 }, py: 1.5, borderRadius: '10px', fontWeight: 500, fontFamily: "'Plus Jakarta Sans', sans-serif", flex: { xs: 'none', sm: 1, md: 'none' }, whiteSpace: 'nowrap', '& .MuiButton-startIcon': { mx: { xs: 0, sm: undefined } } }}
                    >
                      <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>
                        {t('Card payment')}
                      </Box>
                    </Button>
                    <Button
                      variant="outlined"
                      color="success"
                      startIcon={<PaymentsIcon />}
                      onClick={() => setQuickPayMethod('cash')}
                      aria-label={t('Cash payment')}
                      data-testid="quick-pay-cash"
                      sx={{ minWidth: { xs: 0, sm: 64 }, px: { xs: 1.5, sm: 3 }, py: 1.5, borderRadius: '10px', fontWeight: 500, fontFamily: "'Plus Jakarta Sans', sans-serif", flex: { xs: 'none', sm: 1, md: 'none' }, whiteSpace: 'nowrap', '& .MuiButton-startIcon': { mx: { xs: 0, sm: undefined } } }}
                    >
                      <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>
                        {t('Cash payment')}
                      </Box>
                    </Button>
                  </>
                )}
              </>
            )}
          </Box>
        </Box>
      </Paper>

      <AddPartDialog
        open={partModalOpen}
        maintenance={maintenance}
        setMaintenance={setMaintenance}
        handleClose={() => setPartModalOpen(false)}
      />
      <AddJobDialog
        open={taskModalOpen}
        maintenance={maintenance}
        setMaintenance={setMaintenance}
        handleClose={() => setTaskModalOpen(false)}
      />
      <QuickAddDialog
        open={quickAddPartOpen}
        handleClose={() => setQuickAddPartOpen(false)}
        type="part"
        maintenance={maintenance}
        setMaintenance={setMaintenance}
      />
      <QuickAddDialog
        open={quickAddJobOpen}
        handleClose={() => setQuickAddJobOpen(false)}
        type="job"
        maintenance={maintenance}
        setMaintenance={setMaintenance}
      />
      <CancelMaintenanceDialog
        t={t}
        open={cancelMaintenanceModalOpen}
        handleClose={() => setCancelMaintenanceModalOpen(false)}
      />
      <AssignCustomerDialog
        open={customerModalOpen}
        handleClose={() => setCustomerModalOpen(false)}
        maintenance={maintenance}
        setMaintenance={setMaintenance}
      />
      <CustomerDialog
        open={customerEditDialogOpen && !!maintenance?.customer}
        handleClose={() => setCustomerEditDialogOpen(false)}
        customer={maintenance?.customer}
        updateCustomer={() => {
          // Refresh maintenance to get updated customer data
          axios.get(`/api/maintenances/${id}/`).then((res) => {
            setMaintenance((prev) => ({ ...prev, ...res.data }));
          });
        }}
      />
      <AssignBillingCustomerDialog
        open={billingCustomerModalOpen}
        handleClose={() => setBillingCustomerModalOpen(false)}
        maintenance={maintenance}
        setMaintenance={setMaintenance}
      />
      <AssignBillingCustomerDialog
        mode="leasing"
        open={leasingCustomerModalOpen}
        handleClose={() => setLeasingCustomerModalOpen(false)}
        maintenance={maintenance}
        setMaintenance={setMaintenance}
      />
      <DeductibleDialog
        open={deductibleDialogOpen && !!maintenance}
        handleClose={() => setDeductibleDialogOpen(false)}
        maintenance={maintenance}
        setMaintenance={setMaintenance}
        onError={() => setSaveErrorSnackbar(true)}
      />
      <AssignEmployeeDialog
        open={employeeModalOpen}
        handleClose={() => setEmployeeModalOpen(false)}
        maintenance={maintenance}
        setMaintenance={setMaintenance}
      />
      <VehicleInfoModal
        open={vehicleModalOpen && !!maintenance?.vehicle}
        handleClose={() => setVehicleModalOpen(false)}
        vehicle={maintenance?.vehicle}
        onVehicleUpdated={(updatedVehicle) => {
          // Update the maintenance state with the new vehicle data
          setMaintenance(prev => ({
            ...prev,
            vehicle: updatedVehicle,
          }));
        }}
      />
      <VehicleDetailsDialog
        open={vehicleHistoryDialogOpen}
        onClose={() => setVehicleHistoryDialogOpen(false)}
        vehicleId={maintenance?.vehicle?.id}
        initialTab={vehicleHistoryInitialTab}
        onVehicleUpdated={() => {
          // Keep the header and the internal-note box in step with edits made in the dialog
          const vehicleId = maintenance?.vehicle?.id;
          if (!vehicleId) return;
          axios.get(`/api/vehicles/${vehicleId}/`).then((res) => {
            setMaintenance((prev) => (prev?.vehicle?.id === res.data.id ? { ...prev, vehicle: res.data } : prev));
          }).catch(() => {});
        }}
      />
      <ShareMaintenanceDialog
        open={shareModalOpen}
        handleClose={() => setShareModalOpen(false)}
        maintenance={maintenance}
      />
      <EventLogDialog
        open={eventLogDialogOpen}
        handleClose={() => setEventLogDialogOpen(false)}
        maintenance={maintenance}
      />
      <ExtraWorkRequestDialog
        open={extraWorkDialogOpen}
        handleClose={() => setExtraWorkDialogOpen(false)}
        maintenance={maintenance}
        setMaintenance={setMaintenance}
      />
      <WorkOrderConfirmationDialog
        open={confirmationDialogOpen}
        handleClose={() => setConfirmationDialogOpen(false)}
        maintenance={maintenance}
        setMaintenance={setMaintenance}
      />
      <RecordOdometerDialog
        open={odometerDialogOpen}
        handleClose={() => setOdometerDialogOpen(false)}
        maintenanceId={maintenance?.id}
        vehicleId={maintenance?.vehicle?.id}
        currentOdometer={maintenance?.vehicle_latest_odometer}
        currentHourMeter={maintenance?.vehicle_latest_hour_meter}
        setMaintenance={setMaintenance}
        mode="maintenance"
      />
      <ExtraLookupConfirmDialog
        open={extraLookupDialogOpen}
        onClose={() => setExtraLookupDialogOpen(false)}
        onConfirm={() => handleVehicleLookup(true)}
        quotaInfo={extraLookupQuotaInfo}
        isTrial={vehicleLookupQuota?.is_trial}
      />
      <EditPartDialog
        open={editPartDialogOpen && !!selectedPart}
        handleClose={() => setEditPartDialogOpen(false)}
        part={selectedPart}
        maintenanceId={maintenance?.id}
        setMaintenance={setMaintenance}
        maintenance={maintenance}
        onSwapEstimate={(part) => { setEditPartDialogOpen(false); setSwapEstimateLine(part); }}
      />
      <SwapEstimatePartDialog
        open={!!swapEstimateLine}
        onClose={() => setSwapEstimateLine(null)}
        line={swapEstimateLine}
        maintenanceId={maintenance?.id}
        onSwapped={(data) => setMaintenance(data)}
      />
      <EditJobDialog
        open={editJobDialogOpen && !!selectedJob}
        handleClose={() => setEditJobDialogOpen(false)}
        job={selectedJob}
        maintenanceId={maintenance?.id}
        setMaintenance={setMaintenance}
        isMaintenanceInProgress={maintenance?.state === 'in_progress'}
        maintenance={maintenance}
      />
      <OrderDiscountDialog
        open={orderDiscountDialogOpen}
        handleClose={() => setOrderDiscountDialogOpen(false)}
        maintenance={maintenance}
        setMaintenance={setMaintenance}
      />
      <AiEstimateJobDialog
        open={aiEstimateOpen}
        handleClose={() => setAiEstimateOpen(false)}
        maintenance={maintenance}
        setMaintenance={setMaintenance}
        onJobCreated={handleAiJobCreated}
      />
      <QuickPayConfirmDialog
        open={quickPayMethod !== null}
        method={quickPayMethod}
        maintenance={maintenance}
        total={quickPayTotal}
        handleClose={() => setQuickPayMethod(null)}
        onInvoiceCreated={(invoice, method) => navigate(`/invoices/${invoice.id}?pay=${method}`)}
        onBillingSettingsNeeded={() => setInvoiceDialogOpen(true)}
      />
      <CreateInvoiceDialog
        open={invoiceDialogOpen}
        handleClose={() => setInvoiceDialogOpen(false)}
        maintenance={maintenance}
        onInvoiceCreated={(invoice) => navigate(`/invoices/${invoice.id}`)}
      />
      <ChangeVehicleDialog
        open={changeVehicleDialogOpen}
        handleClose={() => setChangeVehicleDialogOpen(false)}
        maintenance={maintenance}
        setMaintenance={setMaintenance}
      />
      <OfferDialog
        open={offerDialogOpen}
        handleClose={() => setOfferDialogOpen(false)}
        maintenance={maintenance}
        allowSend={maintenance?.state === 'quote'}
        onOfferSent={async (recipient, result) => {
          setOfferDialogOpen(false);
          const problems = [
            result?.email_error ? `${t('quoteSnapshot.emailNotSent')}: ${result.email_error}` : null,
            result?.sms_error ? `${t('quoteSnapshot.smsNotSent')}: ${result.sms_error}` : null,
          ].filter(Boolean);
          const note = problems.length ? ` (${problems.join('; ')})` : '';
          setOfferSentSnackbar(t('Offer sent successfully to') + ' ' + recipient + note);
          try {
            const response = await axios.get(`/api/maintenances/${maintenance.id}/`);
            setMaintenance(prev => ({ ...prev, ...response.data }));
          } catch (err) {
            // Ignore re-fetch errors
          }
        }}
      />
      <QuoteHistoryDialog
        open={quoteHistoryOpen}
        handleClose={() => setQuoteHistoryOpen(false)}
        maintenance={maintenance}
      />
      <ConfirmStateChangeDialog
        open={confirmDialogOpen}
        handleClose={() => {
          setConfirmDialogOpen(false);
          setPendingStateChange(null);
        }}
        onConfirm={confirmStateChange}
        currentState={maintenance?.state}
        targetState={pendingStateChange}
        hasActiveBooking={maintenance?.has_active_booking}
        invoiceReopenInfo={getInvoiceReopenInfo(maintenance)}
        maintenance={maintenance}
        odometerRequired={!!currentOrganization?.require_odometer_on_completion}
      />
      <WaitingReasonDialog
        open={waitingReasonDialogOpen}
        handleClose={() => setWaitingReasonDialogOpen(false)}
        onConfirm={handleWaitingWithReason}
      />
      <CompletionDialog
        open={completionDialogOpen}
        handleClose={() => setCompletionDialogOpen(false)}
        maintenance={maintenance}
        setMaintenance={setMaintenance}
      />
      <SupplierOrderDialog
        open={supplierOrderDialogOpen}
        onClose={() => {
          setSupplierOrderDialogOpen(false);
          setSupplierOrderIntegration(null);
        }}
        maintenance={maintenance}
        integrationId={supplierOrderIntegration?.integrationId}
        integrationName={supplierOrderIntegration?.integrationName}
        unorderedParts={supplierOrderIntegration?.parts || []}
        onOrderPlaced={async () => {
          const response = await axios.get(`/api/maintenances/${id}/`);
          setMaintenance(response.data);
        }}
      />

      <ApplyPackageDialog
        open={applyPackageDialogOpen}
        handleClose={() => setApplyPackageDialogOpen(false)}
        maintenance={maintenance}
        setMaintenance={setMaintenance}
      />

      <CopyFromMaintenanceDialog
        open={copyFromDialogOpen}
        handleClose={() => setCopyFromDialogOpen(false)}
        maintenance={maintenance}
        setMaintenance={setMaintenance}
      />

      {currentOrganization?.has_bosch_core_integration && (
        <BoschDiagnosticsDialog
          open={boschDialogOpen}
          handleClose={() => setBoschDialogOpen(false)}
          maintenance={maintenance}
          setMaintenance={setMaintenance}
          onSaved={(message) => setBoschSavedSnackbar(message)}
        />
      )}

      {currentOrganization?.has_cabas_integration && (
        <CabasEstimateDialog
          open={cabasDialogOpen}
          onClose={() => setCabasDialogOpen(false)}
          maintenance={maintenance}
          onOpenMaintenance={(otherId) => {
            setCabasDialogOpen(false);
            navigate(`/maintenances/${otherId}`);
          }}
          onImported={async (result) => {
            setCabasDialogOpen(false);
            setCabasSnackbar({
              severity: 'success',
              message: result.changed ? t('cabas.imported') : t('cabas.alreadyImported'),
            });
            try {
              const response = await axios.get(`/api/maintenances/${id}/`);
              // The import rewrites the insurance fields: reset their blur-save baselines too.
              setMaintenance(withOriginalInsuranceFields(response.data));
            } catch (err) {
              setCabasSnackbar({ severity: 'warning', message: t('cabas.refreshFailed') });
            }
          }}
        />
      )}

      {currentOrganization?.oem_service_enabled && (
        <OemServiceDialog
          open={oemDialogOpen}
          handleClose={async () => {
            setOemDialogOpen(false);
            try {
              const response = await axios.get(`/api/maintenances/${id}/`);
              setMaintenance(response.data);
            } catch (err) {
              // Refetch is best-effort — the order view still shows pre-attach data,
              // so tell the user instead of an unhandled rejection.
              setOemRefreshFailedOpen(true);
            }
          }}
          mode="augment"
          maintenanceId={maintenance?.id}
          vehicleId={maintenance?.vehicle?.id}
          vehicleData={maintenance?.vehicle}
          initialMileage={maintenance?.vehicle?.latest_odometer}
          onAttached={() => setOemAttachedOpen(true)}
        />
      )}

      {/* Work Number Edit Dialog */}
      <Dialog
        open={editWorkNumberOpen}
        onClose={() => setEditWorkNumberOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>{t('Edit work number')}</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label={t('Work number')}
            fullWidth
            value={editWorkNumberValue}
            onChange={(e) => setEditWorkNumberValue(e.target.value)}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                handleSaveWorkNumber();
              }
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setEditWorkNumberOpen(false)}>
            {t('Cancel')}
          </Button>
          <Button onClick={handleSaveWorkNumber} variant="contained">
            {t('Save')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Description Edit Dialog */}
      <DescriptionEditDialog
        open={editDescriptionOpen}
        onClose={() => setEditDescriptionOpen(false)}
        draftKey={descriptionDraftKey}
        initialValue={maintenance?.description || ''}
        initialShowToCustomer={descriptionInitialShowToCustomer}
        onSave={handleSaveDescriptionApi}
        onDraftChange={setHasDescriptionDraft}
      />

      {/* Work Order PDF Language Dialog */}
      <Dialog
        open={workOrderDialogOpen}
        onClose={() => setWorkOrderDialogOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>{t('Work Order PDF')}</DialogTitle>
        <DialogContent>
          <LanguageSelect
            fullWidth
            size="small"
            sx={{ mt: 1 }}
            value={workOrderLanguage}
            label={t('Language')}
            onChange={(e) => setWorkOrderLanguage(e.target.value)}
          />
          <FormGroup sx={{ mt: 1 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={workOrderIncludePrices}
                  onChange={(e) => { setWorkOrderIncludePrices(e.target.checked); localStorage.setItem('workOrderIncludePrices', e.target.checked); }}
                />
              }
              label={t('Include prices')}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={workOrderIncludeCustomerNotes}
                  onChange={(e) => { setWorkOrderIncludeCustomerNotes(e.target.checked); localStorage.setItem('workOrderIncludeCustomerNotes', e.target.checked); }}
                />
              }
              label={t('Include customer notes')}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={workOrderIncludeInternalNotes}
                  onChange={(e) => { setWorkOrderIncludeInternalNotes(e.target.checked); localStorage.setItem('workOrderIncludeInternalNotes', e.target.checked); }}
                />
              }
              label={t('Include internal notes')}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={workOrderIncludeSignatures}
                  onChange={(e) => { setWorkOrderIncludeSignatures(e.target.checked); localStorage.setItem('workOrderIncludeSignatures', e.target.checked); }}
                />
              }
              label={t('Include signature fields')}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={workOrderShowPartCodes}
                  onChange={(e) => { setWorkOrderShowPartCodes(e.target.checked); localStorage.setItem('workOrderShowPartCodes', e.target.checked); }}
                />
              }
              label={t('Show part codes')}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={workOrderIncludeSchedule}
                  onChange={(e) => { setWorkOrderIncludeSchedule(e.target.checked); localStorage.setItem('workOrderIncludeSchedule', e.target.checked); }}
                />
              }
              label={t('Show booking time')}
            />
          </FormGroup>
        </DialogContent>
        <DialogActions sx={{ flexWrap: 'wrap', rowGap: 1 }}>
          <Button onClick={() => setWorkOrderDialogOpen(false)}>
            {t('Cancel')}
          </Button>
          <Button
            onClick={handleOpenWorkOrderInTab}
            variant="outlined"
            startIcon={<OpenInNewIcon />}
          >
            {t('Open')}
          </Button>
          <Button
            onClick={handleDownloadWorkOrder}
            variant="outlined"
            startIcon={<FileDownloadIcon />}
          >
            {t('Download')}
          </Button>
          <Button
            onClick={() => handlePrintWorkOrder(workOrderLanguage)}
            variant="contained"
            startIcon={<PrintIcon />}
            data-testid="work-order-dialog-print-button"
          >
            {t('Print')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Tire Swap Dialog */}
      {tireHotelEnabled && (
        <TireSwapDialog
          open={tireSwapDialogOpen}
          onClose={() => setTireSwapDialogOpen(false)}
          vehicleId={maintenance?.vehicle?.id}
          vehicle={maintenance?.vehicle}
          customer={maintenance?.customer}
          maintenanceId={maintenance?.id}
          onSwapCompleted={async () => {
            setTireSwapDialogOpen(false);
            // Re-fetch maintenance to show the auto-created job line
            try {
              const res = await axios.get(`/api/maintenances/${id}/`);
              setMaintenance((prev) => ({ ...prev, ...res.data }));
            } catch (_) { /* ignore */ }
          }}
        />
      )}

    </Box>
  );
}

export default withTranslation()(MaintenanceProcessView);
